export const en = {
    "k_d9a4808a": "Default red",
    "k_ba84332e": "PCG blue",
    "k_c26ac7b5": "Tencent Blue",
    "k_8ddd72b1": "Sky blue",
    "k_9e5074ae": "Page/link jump failed: {arg_0}",
    "k_7dabc5c0": "Invalid page path",
    "k_2064a310": "Path resolution failed: Dynamic path parameters cannot be empty",
    "k_f6c43c82": "Dynamic path resolution failed",
    "k_a5cfd0b9": "File names cannot contain Chinese characters",
    "k_671ea1f5": "Unresponsive",
    "k_66080238": "The response content is incorrect",
    "k_7fc10dac": "The loadAmdModule function call is missing the necessary amdKey parameter",
    "k_95610e57": "Application information",
    "k_e852b234": "Release management",
    "k_eb8e4960": "Authorized",
    "k_506326d2": "Log| data",
    "k_f5ed4e00": "Rights management",
    "k_dbeaa94e": "Set",
    "k_fb10ca0": "Page list",
    "k_4f007a55": "Add page",
    "k_686d8fb2": "Label management",
    "k_98aed9be": "Generic configuration",
    "k_295efc94": "Application ID",
    "k_20cba5c": "Apply Chinese names",
    "k_409f2431": "Described",
    "k_9ff5ee55": "Type",
    "k_5a4ecbd5": "Operating products",
    "k_9d32cc23": "Managers",
    "k_263d97ff": "Developers",
    "k_c193dc90": "Page theme color",
    "k_9a83c869": "Design style",
    "k_a7863779": "Default layout style",
    "k_f9a1dc10": "Web page icon",
    "k_3cc810ad": "Web page icons (favicon) Configure the icons displayed in tabs by the browser",
    "k_8a679250": "Home",
    "k_92841cb4": "Pages redirected by the application home page and root path (/); support configuring pages with page path as/as the default application home page",
    "k_ad62fe85": "403 Redirect",
    "k_a28cc400": "The page redirected when requesting the interface to return to 403",
    "k_12b8abc6": "Hide page progress bar",
    "k_2c18c818": "Whether to hide the loading progress bar at the top of the page",
    "k_49de27d7": "Message reminder style",
    "k_7cd6e7cc": "Defines how to display error messages when the page is running. The default is \"Notification floating layer\"",
    "k_24106a88": "Watermarking function",
    "k_e94bfcd9": "What is turned on here is the global watermark function (effective for all pages). If you want a single page to take effect, please go to the page to set it separately.",
    "k_cf117737": "Xiaoman feedback",
    "k_f50a9b5a": "What is opened here is the small full function of the formal environment.",
    "k_5b4ffd97": "Xiaoman is a platform for satisfaction feedback, and Xiaoman ID is the unique ID of your management platform.",
    "k_31263a7f": "If you need to understand Xiaoman related content and generate Xiaoman ID, you can go to Xiaoman's official website.",
    "k_c2d9342c": "Front-end monitoring",
    "k_59ee9f84": "What is turned on here is the platform's built-in runtime front-end monitoring.",
    "k_552e0834": "Opening helps the platform locate specific issues more quickly",
    "k_c01eb690": "Agent reporting",
    "k_71a3695f": "The default is turned off, and the front-end is used to report directly during runtime",
    "k_114720f6": "When turned on, use a background agent for reporting at runtime",
    "k_812ef8c4": "Announcement",
    "k_e859a2e0": "Open here is the edit time station announcement configuration, and runtime station announcement display",
    "k_d897b344": "Application navigation",
    "k_ff847a4c": "App navigation is the navigation configuration for all pages at runtime, with lower priority than individual page configurations",
    "k_f89e924a": "Application menu",
    "k_25512510": "The application menu is the menu configuration of all pages at runtime, and has lower priority than the individual configuration of pages",
    "k_fcd32904": "Application header",
    "k_11f715eb": "The application header is configured for all pages at runtime, and has lower priority than the individual configuration of pages",
    "k_64c881e7": "Application Footer",
    "k_a801cdc0": "The application footer is the footer configuration of all pages at runtime, and has lower priority than the individual configuration of pages",
    "k_2dfa9b23": "Visible range",
    "k_c05af489": "Extended configuration",
    "k_6293d5c1": "Custom layout component configuration",
    "k_497ac1f1": "Global Route Guard",
    "k_82d3fe18": "Enterprise WeChat application configuration",
    "k_e2880003": "Apply LessCode",
    "k_65497236": "Global script configuration",
    "k_996f55a6": "Global icon configuration",
    "k_130a364d": "Front-end monitoring configuration",
    "k_9a2ca24a": "Top navigation",
    "k_cd480ec5": "User information",
    "k_1cba5fce": "Application name",
    "k_4e0f78e9": "Application Logo",
    "k_ac4e9d62": "Context switch",
    "k_2f969c12": "Help documentation",
    "k_86ef7db0": "I want feedback",
    "k_5ab53ef0": "Application Quick Switch Panel",
    "k_ddc2a038": "Fixed head navigation",
    "k_f7a98f36": "Display page hierarchy",
    "k_3a05b280": "Use breadcrumbs below the navigation to show the hierarchical relationship of the page. Example:<br/>",
    "k_70cc46df": "Primary catalog/Secondary catalog/Page xxx",
    "k_f548632d": "Display recent access routes",
    "k_5cb6d7c6": "Display recently visited pages below the navigation to facilitate rapid business jumps",
    "k_ab70844c": "Display watermarks to distinguish environments",
    "k_69f6080d": "Watermarks are displayed in the navigation bar of the development environment and test environment to prevent erroneous operations",
    "k_14dbc5e": "Common query parameters",
    "k_807b4485": "The configuration of public query parameters is spliced into the linked query parameters in the form of key = value, and the components that switch parameters are displayed in the top navigation bar.",
    "k_bf012fb5": "Enable business isolation",
    "k_8f2c3513": "Menu group",
    "k_6334a7d1": "Right Express Entrance",
    "k_e1073a27": "Navigation bar component",
    "k_c2e00121": "Default avatar drop-down menu",
    "k_5ab431da": "Customize avatar drop-down menu",
    "k_b9250eb": "Permission configuration",
    "k_8ed73419": "Left menu",
    "k_d6c15dbf": "Menu width",
    "k_5bb33fd0": "Menu option configuration",
    "k_2e41613a": "Display application title",
    "k_d60bff84": "Display menu title",
    "k_18e37385": "Expand submenu by default",
    "k_49afbf7c": "Accordion mode",
    "k_d2a1abd": "After opening, the left menu will only expand the currently selected menu items, and other menu items will not expand",
    "k_6b48f43d": "Display search box",
    "k_70789227": "Menu configuration",
    "k_3e0d1f1f": "Approval process",
    "k_b0bb41bb": "Workflow",
    "k_4af63156": "High level flow",
    "k_9251baf8": "Recording is performed",
    "k_485b2fe0": "Global configuration",
    "k_ccd9cc09": "Data source",
    "k_4a13fd75": "Release record",
    "k_b6404365": "Environmental management",
    "k_cb1523d3": "Component management",
    "k_82815987": "Offline tasks",
    "k_d170f433": "Application related authorization",
    "k_1f7cd3b0": "Authorization database",
    "k_6e1950df": "Component store authorization",
    "k_b07f0e3c": "Application key",
    "k_eee091b6": "Apply COS",
    "k_5d02d01": "Access third-party authentication",
    "k_590055d5": "Set up third-party authentication interface",
    "k_e4f4daaf": "Back-end authentication data source ",
    "k_85ee44bd": "First set the data source of the third-party authentication interface type",
    "k_5a7180ee": "Links to third-party rights systems",
    "k_7d16762a": "Log query",
    "k_be264c8b": "Role management",
    "k_66b1d735": "User management",
    "k_fb75e62e": "Custom permission",
    "k_3350e5ed": "Interface management",
    "k_708eae6": "Advanced configuration",
    "k_d42eb49e": "Announcement management",
    "k_c6731ee3": "Branch management",
    "k_9a7886ed": "Open multiple branches",
    "k_28d0a7dd": "After opening, the default branch is the master branch. Users can create or switch branches, and the operations between branches are independent of each other.",
    "k_2efbea3d": "Branch protection",
    "k_74cb1461": "After opening, users will not be allowed to make modifications directly in the master. They can only update the master through branch merge",
    "k_c01afbef": "Branch association environment",
    "k_6c9c4aee": "After opening, when a branch is created, the environment associated with the branch will be created and published at the same time; when the branch is deleted, the associated environment will also be deleted",
    "k_eb7c1610": "Publish settings",
    "k_d2d59602": "Delete application",
    "k_20f429c": "Open a pre-release environment",
    "k_6623f210": "Before releasing the formal environment, you will first publish to the pre-release environment by default, and then continue to publish to the formal environment after passing the verification. The process is as follows:",
    "k_ed7085c7": "Open heuristic approval",
    "k_c317bdc6": "Versions need to be approved to be released to the formal environment before they can be released to the formal environment. The default approver is the direct superior",
    "k_375663fa": "Allow release directly from the development environment to the official environment",
    "k_9fa8e09a": "Start the publish or rollback push process",
    "k_84b9b9d8": "Editor settings",
    "k_71780009": "Enable ESLint checking",
    "k_b88b8737": "After configuration, you can get ESLint check in the LessCode editor",
    "k_cdc148dd": "ESLint configuration",
    "k_92d33cba": "Illegal path,key={arg_0}",
    "k_e7967770": "Monaco Editor failed to load [{arg_0}]",
    "k_a0e0f1d7": "Using the current version",
    "k_79f7a837": "Use remote versions",
    "k_216c1998": "Use {arg_0} version",
    "k_2926ff7": "Keep both versions",
    "k_288dca7b": "JSON check failed",
    "k_572ee3e": "Please manually resolve the following conflicts:",
    "k_b3641d9": "Conflict pending",
    "k_9346c618": "The previous",
    "k_c0a9baee": "The next",
    "k_32db19dd": "Flag conflict resolved",
    "k_3c906aba": "Do not merge, save directly locally",
    "k_c0ed04": "Have been merged",
    "k_b5e4d814": "To be solved",
    "k_94e9d997": "Unmerge",
    "k_7d824d0f": "Consolidated",
    "k_d1f81e1e": "Conflict resolution",
    "k_da1a5fd9": "Compile {arg_0}",
    "k_1481c444": "Compilation of {arg_0} failed: {arg_1}",
    "k_4939c751": "Compile {arg_0} failed:",
    "k_9c1e9ff5": "Current change",
    "k_6f1ecf52": "<<<<<<< {arg_0}",
    "k_5e9b558c": "Latest change",
    "k_90fc9fac": ">>>>>>> {arg_0}",
    "k_13a1ae98": "There is a conflict with the modification merge of {arg_0} into {arg_1}. Please manually resolve the conflict and submit the merge.",
    "k_5dd444e8": "Application configuration",
    "k_f3717392": "Navigation and menus",
    "k_5cd23c3e": "Global LessCode",
    "k_218cab56": "Head script",
    "k_b33f454c": "Body Script",
    "k_3c5a529": "Project Module ({arg_0})",
    "k_2caf5ae8": "Page information",
    "k_99237951": "{arg_0} Layout",
    "k_a119f7fa": "Missing necessary parameters for three-way merge",
    "k_e8048190": "{arg_0} Services: {arg_1}",
    "k_b32f7432": "Saved successfully",
    "k_e08533af": "Some fields failed to save",
    "k_2b870b4b": "Save failed",
    "k_d0df0a1d": "Merge failed, save and cancel",
    "k_1914e4": "The loading function already exists",
    "k_5d5d5d09": "[FormObject] Getting an unloaded formProp is not allowed, path={arg_0}",
    "k_d527de9e": "[FormObject] Duplicate key loading is not allowed, key={arg_0}",
    "k_c7091857": "Duplicate loading is not allowed, key={arg_0}, bizId={arg_1}, path={arg_2}",
    "k_91196246": "Basic data",
    "k_96bcb21f": "Field prop configuration not found, key={arg_0}",
    "k_90b8b9b9": "There is a conflict in modifying the merge. Please manually resolve the conflict and submit the merge.",
    "k_922ee988": "MaterialContainer: config cannot be empty",
    "k_7a7df20b": "MaterialContainer: id {arg_0} has been used. Please change it to another id",
    "k_4c4ddb6d": "[routeFactory] Unable to find the corresponding materialId: {arg_0}",
    "k_3d1a6848": "Announcement",
    "k_3e0857e6": "To-do",
    "k_4e283f52": "Skip to edit page",
    "k_9b1b0c6c": "Access using Mini programs",
    "k_1a462199": "Default",
    "k_aa07e056": "Menu",
    "k_348661c8": "Drop-down menu",
    "k_f4b9d1ce": "Application",
    "k_1adebcdc": "CLI tool did not start debugging command. Please check and try again",
    "k_d9fad8fc": "The https service is started locally, but the client requests the http interface.",
    "k_53525e4": "Switching to https",
    "k_5c5bafb7": "The http service is started locally, but the client requests the https interface.",
    "k_618ccf3b": "Switch to http",
    "k_8e240863": "Local developer tools launch https debugging mode",
    "k_9ac8d514": "Development tools how to turn on https local services",
    "k_13969097": "The https page prohibits loading http resources, so loading local development resources failed.",
    "k_d91ee4a": "Pages are reloaded using http",
    "k_d5bd0640": "Module",
    "k_c7ec97ab": "Determine",
    "k_9e48cac4": "Cancel",
    "k_7876b718": "Unfortunately, loading local development {arg_0} failed",
    "k_364bed80": "The request for the local development interface failed, which is usually caused by restrictions set by the browser. You can follow the following instructions to investigate one by one:",
    "k_c5938325": "Scene",
    "k_72401e86": "- The console reported an error:",
    "k_bb4c927a": "Solution",
    "k_edd438c2": "The request for local development interface failed. Please use Chrome browser for development",
    "k_305b32b3": "Assembly",
    "k_8e4e67fa": "Initialize the hmr of the component",
    "k_4dec3fe": "Loading failed. Please save the page and refresh it",
    "k_3e526a83": "Component loading...",
    "k_6f50238b": "Initialization component store request:{arg_0}",
    "k_ca1882be": "Component {arg_0} is blocked from instantiation because of the url parameter",
    "k_c62b50a8": "[simple-hook][{arg_0}] execution failed:",
    "k_2f0d5b88": "There are editors that are opened repeatedly",
    "k_945ddc11": "You have opened another editor on the same page",
    "k_173a924c": "The preview function of the current editor has been suspended",
    "k_8c217a8b": "Activate the current editor",
    "k_988200bf": "Close the prompt",
    "k_c41f48d3": "Data source is updated",
    "k_c1489344": "Force reload",
    "k_4a3296e7": "Project information modification",
    "k_a23c2a6": "Logic or data source changes",
    "k_4b6e4236": "Component framework switching hook compilation failed",
    "k_ac638a8e": "Please resolve conflicts",
    "k_4bd7fc71": "Local lagging remote modifications have been automatically merged",
    "k_54c5aee8": "There is a conflict between the current version and the latest version. Please resolve the conflict and save it",
    "k_480aa94e": "Current version",
    "k_3504595": "Latest version",
    "k_bc9e2cec": "Failed to detect application ID",
    "k_9c6cf492": "Failed to pull application data: {arg_0}",
    "k_ffa21796": "Failed to switch project to obtain data: {arg_0}",
    "k_1abf81d9": "Merge application modification conflict failed, cancel saving",
    "k_616bb31c": "Saved successfully (local lagging remote modifications have been merged)",
    "k_9744f625": "Failed to obtain application settings:{arg_0}",
    "k_e0195c74": "Failed to obtain permission setting:{arg_0}",
    "k_b19d4ff3": "Load failed",
    "k_e94bb974": "Page resource loading failure was detected. Please refresh the page and try again",
    "k_f74babfc": "Refresh the page",
    "k_63eb452e": "Failed to obtain cookies: {arg_0}",
    "k_16ce1b93": "Automatic filling in when initiating",
    "k_2f628aaf": "Page slice",
    "k_d772e0d1": "Process example details",
    "k_83025a92": "Unnamed folding panel",
    "k_b8ef81a0": "Flowsheet ID: `{{job.id}` /URL",
    "k_141fa2c5": "Replication",
    "k_fe083896": "Job.id displayed when creating a new process sheet",
    "k_2765b22f": "Current approvers: {{ job.currentApprovers||  '... ' }}",
    "k_d81b1c61": "Copy information + one-click group activation",
    "k_b2d4c395": "Copy information",
    "k_6310181e": "Hello, please pay attention to the approval document \"{{ job.title }}\"\n\n{{ job.url }}",
    "k_cc304f42": "Process is running",
    "k_77336e3c": "Process: {{ job.title }}",
    "k_fd7071b4": "Refresh",
    "k_9701c2ec": "Page",
    "k_88400715": "Page JS resource loading failed",
    "k_1c40e30e": "Length of page stay",
    "k_4371425a": "Element click",
    "k_6962e060": "Elemental exposure",
    "k_64ca60e6": "Elemental behavior",
    "k_8768cf20": "Other component behavior events other than the \"element click\" event (such as switching tabs, the behavior ID needs to be filled in \"${component ID}:${event ID}\")",
    "k_b2aa654": "Total number of visits",
    "k_5d38c887": "Total visitors",
    "k_7f3cbb3": "Per capita number",
    "k_82f3a35e": "Stay time [Average: seconds]",
    "k_7b01390f": "Stay duration [Maximum: seconds]",
    "k_55902551": "Extended field {arg_0}",
    "k_179d1d10": "Component path",
    "k_81cb80fb": "Modify",
    "k_e65e9d6c": "Error in page operation request parameter",
    "k_8515267d": "Failed to obtain page list",
    "k_6195cfa3": "Merge page modification conflict failed, cancel saving",
    "k_1217471a": "Failed to pull page data: {arg_0}",
    "k_7c89b8c0": "Development environment",
    "k_eb361e9": "Test environment",
    "k_f5bd66e0": "Formal environment",
    "k_95f5015": "Custom environment",
    "k_801ae80d": "Pre-release environment",
    "k_fdfa33f5": "Failed to obtain application environment list",
    "k_7d2a4507": "This environment is already in use by the system. Please set another environment id.",
    "k_d65783ce": "{arg_0} The environment has not been released yet, and there is no comparable version currently",
    "k_7d0bf4f5": "Failed to obtain current page version differences:{arg_0}",
    "k_332aaa52": "Failed to submit version:{arg_0}",
    "k_4b6567de": "Failed to get version list:{arg_0}",
    "k_3712f46e": "Release failed:{arg_0}",
    "k_a397ab58": "Failed to obtain current application version list:{arg_0}",
    "k_62099491": "Failed to synchronize environment data:{arg_0}",
    "k_4d4fb2fe": "Failed to obtain version release content",
    "k_155ae064": "Version termination failed:{arg_0}",
    "k_37bbc2f3": "Operation failed {arg_0}",
    "k_8ae82c14": "Import is successful",
    "k_14533a37": "Import failed: {arg_0}",
    "k_6155e57b": "Failed to execute pre-hook: {arg_0}",
    "k_ef623dfe": "Failed to get import hook: {arg_0}",
    "k_cdede42c": "Page loading failed,{arg_0}",
    "k_dfdd7274": "[getPageDetail] JSON.parse failed",
    "k_e5d094ae": "Agreed",
    "k_4ad83ff3": "Rejected",
    "k_2065fc89": "Missing nodeId",
    "k_45f7c739": "Capture process",
    "k_21767e56": "Flow id",
    "k_8eafd8f8": "Approval",
    "k_39090a8c": "Approval node id",
    "k_c0f02b6d": "Agree/Rejection",
    "k_68a001fc": "Approval opinions",
    "k_dd04887b": "Form data",
    "k_238054ac": "Initiate process",
    "k_77728eba": "Process data",
    "k_ca7cb56f": "Get process configuration",
    "k_5275db4c": "Get approval node information",
    "k_f83449ef": "Get log node information",
    "k_c0b23936": "Get the full process",
    "k_8bdba086": "Title",
    "k_434040f9": "Process title, empty string is not filtered",
    "k_66ca76fd": "Sponsor",
    "k_f4117f5e": "Initiator, empty string is not filtered",
    "k_42c7bb06": "Obtaining process based on type",
    "k_eb51ec65": "Process type",
    "k_9c641f62": "I initiated it.",
    "k_1eee3da2": "That I'm involved",
    "k_79cc91b7": "About me",
    "k_51828d": "Examination and approval daiban",
    "k_6ff01997": "Id: page ID; path: page path; query: query parameters; params: routing parameters",
    "k_74fc2ea3": "Page ID",
    "k_4df10511": "Page name",
    "k_218fe524": "Page title",
    "k_f91f1a04": "Page path",
    "k_afa73ddc": "Global constants",
    "k_e18fb93": "Department ID",
    "k_24790f65": "Department IDs(semicolon; split)",
    "k_559c8dc6": "Center IDs(semicolon; split)",
    "k_2297b92e": "Positions",
    "k_c9f2cb71": "Log in to channel front-end data",
    "k_6c2db129": "You can use the login channel-login hook, according to business needs, visit ctx.frontendData.xxx =... inject data",
    "k_f0b03782": "Front-end API",
    "k_cef231d3": "Open the pop-up window",
    "k_d92652c9": "Open the specified pop-up window on the current page",
    "k_f0721f42": "Pop-up window id that needs to be opened",
    "k_2adf79b1": "Open the parameter transfer of the pop-up window (optional)",
    "k_de91ca00": "Close the pop-up window",
    "k_94fd1ac5": "Close the specified pop-up window on the current page",
    "k_a7550b3a": "Id of the pop-up window that needs to be closed (optional, when the parameter is empty, it means that the currently called pop-up window is closed)",
    "k_ec14de23": "Return value of closing pop-up window (optional)",
    "k_26932b3d": "Open global pop-up window",
    "k_1d08bdb2": "Open a global pop-up window with page type of pop-up window",
    "k_627f6522": "ID of the global pop-up window that needs to be opened (pop-up page id)",
    "k_8f4d4ef7": "Open the transfer parameters of the global pop-up window",
    "k_62eba813": "Configuration item for the global pop-up window, whether keepAlive retains the instance, suffix used to distinguish the instance",
    "k_d09de7b1": "Close the global pop-up window",
    "k_d03427fa": "Close global pop-ups with page type pop-ups",
    "k_9ff6c1c7": "\"Global pop-up window id_suffix suffix\" that needs to be closed (\"Pop-up window page id_suffix \")",
    "k_12b0797c": "Return value of closing global pop-up window",
    "k_73d39db1": "Turn off the configuration item of the global pop-up window. Do you want to destroy the instance?",
    "k_4cf8f45c": "Initiate an HTTP network request",
    "k_e8548831": "The return value is the object after json. parse, other things are consistent with the fetch API",
    "k_15de3a8f": "Request resource address",
    "k_be5485b": "Request parameters",
    "k_68075d8e": "Call cloud function",
    "k_d417a854": "Cloud function id",
    "k_2548f21": "Axios configuration parameters for transparent transmission (optional)",
    "k_91575c1f": "Request data source interface",
    "k_aca16052": "Data source ID",
    "k_8fdb1f9e": "Interface id of the data source",
    "k_4aa05650": "Request parameters for the data source (optional)",
    "k_32ec29ed": "URL parameter",
    "k_888dd51b": "Post parameters",
    "k_acd0529e": "Request header",
    "k_5f79b68f": "Url path parameter, unique to front-end data sources",
    "k_aea7f265": "Wait until all data sources are ready",
    "k_e66628b3": "This method ensures subsequent calls of logical data source variables and methods",
    "k_4f5746ba": "Get the values of public parameters based on key",
    "k_5ffe70a4": "Public parameter key",
    "k_3aaf7073": "Options to get public parameters based on key",
    "k_5a45336a": "Option to re-request public parameters based on key",
    "k_8159f032": "The common parameter component options in the upper left corner of the top navigation are also updated after the request is completed",
    "k_abaf65be": "Method for judging user rights",
    "k_6e8b016d": "Determine whether the current user has custom permissions, such as: w. hasPermission (\"custom-permission-id \")",
    "k_d3ee0d51": "Permission ID (for example,`\"custom-permission-id\"`)",
    "k_c8131ca6": "Jump page",
    "k_7e667622": "Skip to the specified page within the app and keep the current page",
    "k_8937bba9": "Skip to the specified page in the app and close the current page",
    "k_ecbcd43c": "New window opens page",
    "k_e60d9761": "New window opens the specified page",
    "k_db8bd10f": "Get the resolved page path",
    "k_42c96189": "Scroll the page to the target location",
    "k_882e2f7e": "Scroll parameters, please check the front-end API documentation for details",
    "k_fae03fe7": "Confirmation box",
    "k_91f2451d": "Confirmation box configuration item",
    "k_203b66": "Confirmation Box Title",
    "k_114ddf76": "Content of confirmation box",
    "k_aeeca8a8": "Confirm button text",
    "k_fc288d97": "Cancel button text",
    "k_bc6de6f2": "Confirm callback function",
    "k_8acb7f72": "Cancel the callback function",
    "k_3f5a3000": "Gets the specified component instance based on the ID (the return value is Vue instance)",
    "k_9f7a55ce": "Component ID",
    "k_18ef36e8": "Gets an example of the page slice to which the specified component belongs",
    "k_9c25ea2": "Component instance",
    "k_8f03d179": "Introducing front-end common modules",
    "k_bdeab364": "Module path",
    "k_8f6c9596": "Reported",
    "k_b79979ab": "Reported data",
    "k_6c5950ca": "Event name",
    "k_fe3bdda2": "Element id",
    "k_102d9733": "Get behavioral events",
    "k_f5153f68": "Renderer Example",
    "k_62c862d": "Global LessCode instance",
    "k_3c08d9be": "Current page example",
    "k_73fd7845": "Example of page slices on the current home page",
    "k_2c16c9d2": "Mode",
    "k_7e0c6a8b": "Current environment type",
    "k_58f08327": "Current user",
    "k_31212c91": "User ID",
    "k_818c3f63": "English name",
    "k_c415ce1d": "Chinese name",
    "k_bef5e764": "The section name",
    "k_2dc51da8": "Organization name (slash/split)",
    "k_12d3d68": "Organization IDs (semicolon; split)",
    "k_58481ad5": "Avatar picture address",
    "k_ffa8f8db": "Editorial identity",
    "k_a1e9870d": "Whether an administrator",
    "k_f16dd585": "Are signed in",
    "k_e80971f6": "List of roles",
    "k_98888d52": "None in preview mode",
    "k_7c6fcd47": "Role name",
    "k_43927821": "Permission entry",
    "k_f0e7c62e": "Permission item ID",
    "k_8a603ebf": "Page ID associated with the permission item",
    "k_e15c4cd6": "Role name associated with the permission entry",
    "k_7de1ec17": "Center ID",
    "k_258fab2a": "Group ID",
    "k_60038845": "Log out",
    "k_b9843d8a": "Note: You will leave the current page",
    "k_ac776471": "Switch accounts",
    "k_169c9883": "Display the account switching floating window.\n\nYou can wait and get a boolean value indicating whether the user has performed a switching operation.",
    "k_26d2fcd9": "Do you want to refresh the page after switching? Default true",
    "k_92b24ea1": "Global custom events",
    "k_c62f4b2e": "Platform preset events",
    "k_bb2b4cb9": "Global Front Guard",
    "k_7a79173a": "Global postguard",
    "k_e3897292": "Before page destruction",
    "k_785f320d": "Page destruction",
    "k_256b44be": "Page data source ready",
    "k_55a299cb": "Page title modification",
    "k_c0cd96a2": "Surveillance incident",
    "k_e7a9a544": "Event name",
    "k_16036785": "Event handler",
    "k_105baf88": "Listen for events (triggered only once)",
    "k_15e5c942": "Cancel monitoring events",
    "k_1ab8c1a5": "Trigger event",
    "k_d4a9d62c": "Event parameters",
    "k_e372f2e4": "Permissions",
    "k_f9be4ad1": "Get a list of roles",
    "k_7f348e0d": "Get Role-User List",
    "k_3d85e6a6": "Optional, filtered according to business ID",
    "k_cd0555c3": "Optional, filtered based on role ID",
    "k_279c45f4": "Optional, limited by user id or type",
    "k_db87fcc6": "Get role-permission list",
    "k_7dacca34": "Role ID",
    "k_3202894a": "Obtain role-related permissions and users",
    "k_f0734e26": "Get a custom permission list",
    "k_6e169561": "Get a list of built-in permissions",
    "k_3530f0a0": "Get Interface-Permission List",
    "k_a7ec5ea4": "New role",
    "k_90a32c54": "Role information",
    "k_a55a7ae0": "Character English name",
    "k_e8d8436e": "Character's Chinese name",
    "k_223d6da": "Type, which is generally an empty string. If it is a business type role, it is biz",
    "k_96472c02": "Update role",
    "k_51139969": "Only cname can be updated",
    "k_2ca306cf": "Remove roles",
    "k_705f6629": "New permission",
    "k_d3f94caf": "Authority information",
    "k_6bbee035": "English name of authority",
    "k_30e50eed": "Permission Chinese name",
    "k_3fb6a1a4": "When the type is page, the page id can be associated, separated by commas",
    "k_e170e4e": "Update privileges",
    "k_d1582cd3": "Only cname and relatedPages can be updated",
    "k_cc7543f3": "Delete permission",
    "k_8301c6b1": "Add role members",
    "k_51fe1907": "Role member information",
    "k_9a883776": "User English name",
    "k_453d502a": "Name",
    "k_9cfb53e1": "User type",
    "k_926914a6": "Business id, business isolation, required if the role is business type",
    "k_3a9728ab": "Expiration time cutoff, ms",
    "k_13edd81f": "Delete role members",
    "k_4ff0f22b": "Role member record id",
    "k_9409dc33": "Add role permissions",
    "k_85068e89": "Role permission information",
    "k_e3adca26": "Page id, page related permissions are required",
    "k_c964b725": "Delete role permissions",
    "k_5644e476": "Role permission record id",
    "k_f5b083d5": "Batch delete role permissions",
    "k_15a3b5a3": "Role permission record id list",
    "k_f664145f": "Add interface permission binding",
    "k_8de7d690": "Interface permission binding information",
    "k_4b4a1b59": "Interface name",
    "k_53effe81": "Delete interface permission binding",
    "k_c084da63": "Interface permission binding record id",
    "k_d532a596": "Get a list of announcements",
    "k_8d7678d2": "Filter condition",
    "k_5aa163b5": "Refresh Announcement",
    "k_b0885b08": "Watermark",
    "k_dd0849e": "Display watermark",
    "k_f70c4830": "Relevant flow sheet",
    "k_52092425": "Flowsheet ID",
    "k_5cadee77": "Approver",
    "k_dc2b439f": "Process status node ID",
    "k_6cc900fc": "Process status node name",
    "k_655aac6a": "Procedure status",
    "k_740ff4b6": "Environment",
    "k_cb83ebb3": "Entity ID",
    "k_ee653527": "Flow ID",
    "k_429d6b95": "Obtain a separate process list",
    "k_aebfbded": "Flowsheet type",
    "k_4811b215": "Your filters",
    "k_9b54903b": "Get flow sheet details",
    "k_8bf6ae24": "Obtain process approval records",
    "k_d3d1a668": "After process is initiated",
    "k_5d7bf6b6": "Process Configuration ID",
    "k_79f63bf": "Approval data",
    "k_5f7ffe5a": "Approval process",
    "k_7b1edde4": "Reinitiate the process",
    "k_61dc85c1": "Cancellation process",
    "k_eb6d4b42": "Whether the flow order is in progress",
    "k_6734ea01": "Traveler",
    "k_4ae8c9aa": "Can current users approve",
    "k_49eaa2fd": "Re-assign approvers",
    "k_57f040e8": "Approvers, multiple approvers are separated by English comma (,)",
    "k_e4a17591": "Application icon",
    "k_bd4dd7ef": "The application icon is also used in the navigation bar, application list cards, and browser tabs",
    "k_da7bb8c1": "Current page information",
    "k_f895903c": "Main page information",
    "k_586efc1c": "Get the current menu group",
    "k_7dec6c3c": "Set the current menu group",
    "k_afb4aa71": "Menu group name",
    "k_f48a30c7": "Set the currently selected menu item",
    "k_7e490a7e": "Multi-level menu item names",
    "k_132bad1": "Set the current menu closed/expanded state",
    "k_4dbacdc8": "Whether to close the menu",
    "k_fa23b63b": "Get current menu data",
    "k_bedeeb66": "Get platform menu data",
    "k_916a77e7": "Set menu data",
    "k_7e1290ed": "Menu data",
    "k_e797ccc3": "Get the current menu name",
    "k_4cf0f0d9": "Current domain name",
    "k_d9d8a40a": "Current path",
    "k_c00f7bc": "Route query parameters",
    "k_6da6881a": "Routing dynamic parameters",
    "k_f6b95efe": "Are Mini programs",
    "k_c4486ea2": "Whether the screen is narrow",
    "k_3bf07f73": "Screen size information",
    "k_d0722a3": "Prompt",
    "k_53324722": "Success prompt",
    "k_7b4c99db": "Prompt content",
    "k_67160703": "Warning prompt",
    "k_912d2327": "Error prompt",
    "k_276350": "Loading Tips",
    "k_697cd19b": "Role",
    "k_7454f20": "Content",
    "k_35c5ef3b": "Behavior event",
    "k_a7445e17": "Pop-up message window",
    "k_e0784cdf": "A confirmation box pops up",
    "k_dc53da43": "Display vertically centered",
    "k_5aec5cc9": "Icon",
    "k_d7c5ccb1": "Confirmed callback function",
    "k_c5bb25fa": "Canceled callback function",
    "k_2a72389b": "Pop-up text input box",
    "k_569ec1f3": "Default input text",
    "k_83e832aa": "Text type",
    "k_d9335985": "Allow empty strings",
    "k_1b7a7f0": "Pop up a prompt",
    "k_9a6f497a": "Duration",
    "k_b6200d91": "Pop-up notification box",
    "k_c67dcb32": "Notification type",
    "k_571ea30a": "Position",
    "k_d6a5c795": "Verification form",
    "k_fae573e4": "Form object",
    "k_bd571250": "Check error message",
    "k_28f1d79c": "Call the LessCode method",
    "k_4dfab82e": "LessCode method name",
    "k_2b78c99b": "Copy text",
    "k_6cbb034e": "Text",
    "k_5180256": "Whether to pop up a copy success reminder",
    "k_237ad5c": "Data source operations",
    "k_e7fe36bf": "Data source ID",
    "k_988d37c": "Data source method name",
    "k_cd70652e": "Data source method input parameters",
    "k_551045b7": "Data source reinitialization",
    "k_2b9ae399": "Upload to COS",
    "k_f31a8864": "COS bucket ID (generally \"default\")",
    "k_7a884ba": "File content (string or Blob)",
    "k_245df27d": "Upload to path",
    "k_24ab53ce": "Multi-environment configuration (optional)",
    "k_1ce6b236": "Upload header (optional)",
    "k_3d26a736": "File URL generated after upload",
    "k_13a8199d": "Excel export",
    "k_b84166fd": "Export data",
    "k_9cd4de06": "Exported fields",
    "k_3bf04fc0": "Field key",
    "k_9d7b7cda": "Field name",
    "k_4b3c20e6": "File name",
    "k_366deca9": "Sheet name",
    "k_72e2a3ca": "Export format",
    "k_ffb2cb19": "Excel import",
    "k_bc85a2de": "Parameters",
    "k_33f341a6": "Whether it is raw data",
    "k_d797a577": "Whether to output the date type as Date",
    "k_a07ade": "Character set",
    "k_a58e76c4": "Extract file data",
    "k_20e57fd2": "Whether to choose multiple choices",
    "k_170853af": "Whether folders are supported",
    "k_c8cd5c3d": "Jump link",
    "k_bd8fd6b6": "Link address",
    "k_7813c8d2": "Whether a new window opens",
    "k_83dee5ca": "Return to the previous page",
    "k_60faae12": "Refresh page slice",
    "k_95ef785e": "Scroll page",
    "k_3e45c1a2": "Scroll position",
    "k_c489e648": "Vertical Scroll Distance (px)",
    "k_53e5978f": "Component ID",
    "k_3c4a03fc": "Component offset type",
    "k_e3c840a4": "Component offset distance (px)",
    "k_2ec227fd": "Scrolling behavior",
    "k_a02b9455": "Save Draft",
    "k_72789283": "Draft namespace",
    "k_9419baaa": "Whether to display confirmation pop-up window",
    "k_8a892778": "Restore draft",
    "k_eca0065d": "Whether to keep the draft after cancellation",
    "k_e1ac22e6": "Delete draft",
    "k_7fd7aa57": "Email notification",
    "k_b2408937": "Recipient mailbox",
    "k_574c45bf": "CC to email",
    "k_8b3d6bc9": "Secret email address",
    "k_25273424": "Subject line of your email",
    "k_2a5af184": "Mail content",
    "k_74a14ee8": "Enterprise Micro Robot Notice",
    "k_4cdb7f0f": "Robot ID",
    "k_35433cae": "Notification content",
    "k_7864dd63": "Whether a success reminder pops up",
    "k_781e2f73": "Enterprise WeChat Notice",
    "k_9dadd48": "Receiver, multiple recipients are separated by English comma (,)",
    "k_3fa7cb03": "Notice Title",
    "k_64574092": "Notification describes",
    "k_c58ad71c": "Notifications link",
    "k_5d3edd0d": "Notification button text",
    "k_c3e7de2c": "Arouse corporate WeChat",
    "k_81ce6af6": "Send GPT message",
    "k_d8da8e3b": "System preset Prompt",
    "k_b771908f": "Message content",
    "k_edbfb7bf": "Return message form",
    "k_f149481e": "JSON string",
    "k_e3d80c02": "Calling method",
    "k_de254a4c": "Language model",
    "k_3f9c7e13": "Interface",
    "k_4d6c5b12": "Set",
    "k_f6e68ca8": "Generally used to set UI visibility",
    "k_8f71bb05": "You can set associated pages, page-level permissions, belonging to \"page permissions\"",
    "k_dc7d645c": "You can bind the data source interface, and the user must have this permission after binding; you can also use it as an application-level permission without binding the interface",
    "k_dbd89e4e": "You can set the authority collection represented by this authority to facilitate empowerment",
    "k_72288ae6": "View page data",
    "k_d27542c4": "New page data",
    "k_f6f2bdda": "Update page data",
    "k_31802b06": "Delete page data",
    "k_7a6784c1": "Upload",
    "k_58775278": "Views",
    "k_a6db7578": "To view page data, you can call the data source interface on the corresponding page: get/list/count/request/custom_*",
    "k_77114af3": "Inheriting built-in permissions: View application data",
    "k_697b3a2c": "New",
    "k_d398b57f": "To create new page data, you can call the data source interface: create on the corresponding page",
    "k_541cf25b": "Inheriting built-in permissions: Create new application data",
    "k_92dc87c4": "Update",
    "k_9bdfd184": "To update page data, you can call the data source interface: update on the corresponding page",
    "k_7f12cdee": "Inheriting built-in permissions: Update application data",
    "k_3c26b6cc": "Delete",
    "k_222b9012": "To delete page data, you can call the data source interface: delete on the corresponding page",
    "k_3a988fdd": "Inheriting built-in permissions: Delete application data",
    "k_755292ba": "You can use the upload component on the page",
    "k_c0a30a4d": "Inheriting built-in permissions: Upload application data",
    "k_3a4f81ec": "This deployment version does not support obtaining department information",
    "k_42dac712": "Failed to obtain cloud function list",
    "k_58da5ae2": "Failed to obtain data source interface",
    "k_c6ae8625": "Failed to obtain role user list",
    "k_13a91368": "Failed to obtain role list",
    "k_4328b559": "Do not have permission to view the current environment permission configuration",
    "k_1165ae17": "It is suspected that the corresponding environment has not been released. Please send the version first and visit again.",
    "k_11febe51": "Method",
    "k_f5cd078f": "Global instance/Global LessCode instance",
    "k_475e8e0f": "Operation",
    "k_6e3cca73": "Please choose...",
    "k_f01dd83d": "This data source does not support Action",
    "k_a5a81b50": "Cannot find behavior atom with id={arg_0}",
    "k_6bc5d09c": "Pop-up window",
    "k_b7f6e22c": "Please don't tell others.",
    "k_2e31d2c1": "Initialization",
    "k_38319534": "The data source may not be ready yet, ** cannot call the data source method **",
    "k_5e5f6e2c": "Rendering is complete",
    "k_c4903939": "The page rendering is completed",
    "k_fd2154bd": "Current page renderer instance",
    "k_3a1d25e0": "Data source ready",
    "k_4736f697": "The data source method can now be called. If the data source has the configuration of \"automatically pulling data when opening the page\", it will wait for the pulling to complete before executing the logic here",
    "k_adbe1ec9": "Destruction",
    "k_b69805f3": "[Title] Please place components",
    "k_36abb697": "[Content] Please place component",
    "k_9a705dbd": "[Footer] Please place component",
    "k_1d95ad3f": "Attribute",
    "k_292eff31": "Type shown",
    "k_a722db1": "Appearance",
    "k_1b9d7833": "Drawer",
    "k_6e56fd31": "Mobile adaptation",
    "k_dcbfb24": "Direction of drawer",
    "k_a0bfb874": "On",
    "k_d373c2f5": "Right",
    "k_608053e3": "Under",
    "k_b74b2d05": "Left",
    "k_c9532c0f": "Width",
    "k_ee68c4c2": "Height",
    "k_1d29bee4": "Display the title",
    "k_8e8f4d76": "Display footer",
    "k_bbe3cd8b": "Custom title",
    "k_153c239e": "Display the close button in the upper right corner",
    "k_b78610c4": "Function",
    "k_8b0a5d82": "Display mask",
    "k_1825e093": "Support Click on Meng Layer to close",
    "k_76157496": "Support keyboard ESC shutdown",
    "k_20a11748": "Keep instances when shutdown",
    "k_2c03fd1c": "Shutdown parameters",
    "k_552ea40a": "Default return parameters when ESC is closed via the close button in the upper right corner/click on the mask/keyboard",
    "k_a85e651": "Modifying {arg_0} id requires manual updating of LessCode and associated component configurations ",
    "k_4fde6e2b": "{arg_0} Name",
    "k_9e497eb": "{arg_0} Description",
    "k_c8242e52": "Please enter a description",
    "k_d3707e74": "{arg_0}{arg_1} cannot be empty",
    "k_8c9e2fe1": "{arg_0}{arg_1} already exists",
    "k_c3aaf766": "ID consists of letters, numbers, underscores, and dotted lines, and can only start with a letter",
    "k_b38ad245": "System components",
    "k_c4d09e95": "Open",
    "k_a964d573": "Note: Do not call data source methods at this time",
    "k_4a7e579c": "Closed",
    "k_b74f8a6e": "Pop-up window container",
    "k_b9820cc3": "Reset footer",
    "k_486f408d": "Data loading, please wait...",
    "k_c446b47a": "Please select a page (slice)",
    "k_10ab8a98": "The page ( {arg_0} ) does not exist or does not have permission to access. Please contact the application administrator ",
    "k_32559d66": "Page (slice)",
    "k_8d6cfa32": "Page slices in the current page",
    "k_886863ff": "Process node",
    "k_c164976": "Processes and nodes",
    "k_58eb68b8": "Parameters (page/page in-chip parameters are obtained through props.xxx)",
    "k_1263d911": "Load mode",
    "k_49efeb54": "Default mode displays loaded copy and progress bar",
    "k_166d4347": "Space-occupying",
    "k_b90123e9": "Silence",
    "k_24f6ce51": "Navigation",
    "k_12849352": "Page header",
    "k_97542633": "Footer",
    "k_4f7290aa": "Navigation-Menu-Content",
    "k_f2466883": "Navigation-Content",
    "k_6d149e31": "Menu-Content",
    "k_6c269693": "Following the application",
    "k_dce4646": "Fixed",
    "k_fbe7ae1e": "Not fixed",
    "k_bc84d7ca": "Open",
    "k_d45b3ee7": "This is not the page that initiates the process",
    "k_3dfa72a3": "Read-only",
    "k_4ed57936": "Can be used to distinguish whether it is the current [Initiation Process Page] or the [Process Information View Page]",
    "k_665c9970": "Use the data in the form to initiate the process",
    "k_3dc6a067": "Do you want to skip to the process details page immediately",
    "k_1579945c": "Including { id, url } are the process order ID and process order page address respectively.",
    "k_c2ce280e": "Flowsheet page address",
    "k_f185b9aa": "Process initiation time",
    "k_71036c9b": "Please fill in the complete information as required",
    "k_4a42e4ce": "Approval results",
    "k_7ce77cd": "Additional data",
    "k_7aff1b77": "Whether it can be approved",
    "k_a0951a2e": "Approval status",
    "k_351d41f8": "Not entered",
    "k_12d95d6e": "Has agreed",
    "k_54e06e46": "Has rejected",
    "k_55ec099b": "First entry time of the approval node",
    "k_d14daea": "Refused",
    "k_44fb841f": "Approval records",
    "k_6cc38515": "Approval time",
    "k_fa00bbb2": "Approval operation",
    "k_1d73f81f": "Approval operation name (Chinese)",
    "k_ed961e3a": "Approval of additional data",
    "k_a0e67e5f": "Whether the approver can be modified",
    "k_994d8238": "Modifying approvers",
    "k_668bae6f": "Can it be withdrawn?",
    "k_1fe4d4bf": "Processing approval",
    "k_99672127": "Use the currently filled approval comments, additional data, and then agree or reject the approval",
    "k_1cea4d5e": "Operation type (approve or reject)",
    "k_ff07d297": "Approval form information",
    "k_5553721e": "Whether to refresh the page",
    "k_5aca5e7e": "Modification Approver",
    "k_5c8a182c": "Withdraw approval form",
    "k_e6283fe0": "Revocation reason",
    "k_c1b3cb0f": "Save Changes",
    "k_f1458645": "Please enter approval opinions",
    "k_e3e07049": "Approval initiation time",
    "k_e6fb224f": "Please enter reason for withdrawal",
    "k_6700ebc5": "{{ data.item.operation === \"request-cancel\" ? \"Reason for withdrawal\" : \"Approval Opinions\" }}",
    "k_25f752a6": "{{data.item.comment ||'None'}}",
    "k_866f69f2": "New approver",
    "k_e9e3297b": "Data.item.operationName ||\"Unknown operation\"",
    "k_3885bb71": "By",
    "k_102c726b": "Approval failed: {arg_0}",
    "k_a3cad6aa": "Approval Form",
    "k_df78b0e0": "Approval information",
    "k_294189cd": "Node title",
    "k_c3bfd630": "The content output",
    "k_7fdb8aa6": "Whether implemented",
    "k_81770304": "Whether it is runtime",
    "k_55bd96f5": "Execution time",
    "k_8c549f74": "Unable to load this node",
    "k_70ecae12": "Which process",
    "k_d8227216": "Which node",
    "k_f6384246": "Inserted",
    "k_da780fe2": "Trigger refresh method",
    "k_22042ed4": "Preset event A",
    "k_fe78cc40": "Trigger the execution of this event through the behavior of 'Trigger Page Slice Event'",
    "k_a08b60b9": "Custom parameters for triggering event behavior",
    "k_2ba647c1": "Preset Event B",
    "k_411bd345": "Preset event C",
    "k_fb29d0db": "Preset event D",
    "k_cb2c0538": "Preset event E",
    "k_ccf32c61": "Embedded page (slice)",
    "k_bca7b6c3": "Please place the component",
    "k_330cb30d": "Combination",
    "k_b84d2038": "Navigation bar",
    "k_46aa3f41": "Menu bar",
    "k_69092539": "All rights reserved by Tencent",
    "k_a4ea733e": "WUJI",
    "k_305f3524": "Preset footer",
    "k_4ad68318": "Please select a page slice",
    "k_e8e5df89": "Page slice parameters (page slice parameters are obtained through props.xxx)",
    "k_d79bdc25": "It is executed when preset event A is triggered. You can get event parameters XXX through `$event.XXX`",
    "k_a956fbce": "It is executed when preset event B is triggered. You can get event parameters XXX through `$event.XXX`",
    "k_23c9346": "Pre-set event C is executed when triggered. Event parameters XXX can be obtained through `$event.XXX`",
    "k_b1df00e9": "It is executed when preset event D is triggered. You can get event parameters XXX through `$event.XXX`",
    "k_b0c5c32a": "It is executed when preset event E is triggered. You can get event parameters XXX through `$event.XXX`",
    "k_dcc4a296": "Embedded page slice",
    "k_a28ee87e": "Upgrade components",
    "k_6b92e9b6": "Main page",
    "k_c333ec96": "Data",
    "k_46c3e034": "Layout",
    "k_6e635fa8": "[UICore Component]: Invalid custom material panel configuration",
    "k_c06c2c7e": "UICore container",
    "k_c3942516": "Page content",
    "k_bccbb9f8": "Design patterns",
    "k_6736ec1d": "Rendering mode",
    "k_4a333030": "Data pattern",
    "k_adad0e66": "The bound data will be mounted to the internal state.data",
    "k_bcfb16ff": "Incoming data",
    "k_5dc28f4c": "Transparent data source",
    "k_7cf0b757": "Default container type",
    "k_53b1fe9f": "Default root container for layout",
    "k_9dd92ad4": "Customize Materials Panel",
    "k_a39d2cc3": "[Help Document]({arg_0})",
    "k_3173df24": "The palette",
    "k_e22b369d": "Editor UI pruning",
    "k_79536a36": "Data source panel",
    "k_1b40488d": "Styles panel",
    "k_56d71f77": "Action panel",
    "k_ab925eae": "Toolbar",
    "k_54506580": "Cannot find the corresponding pop-up window for [{arg_0}]",
    "k_c85989c4": "Directional icon",
    "k_be0f1047": "Edit class icon",
    "k_8cc21a4e": "Data type icon",
    "k_c4e04048": "Common website icons",
    "k_5362661c": "Prompt Suggestion icon",
    "k_ac70ca3d": "[wuji-lang] Non-existent language key:{arg_0}, optional language {arg_1}",
    "k_d373770d": "The WUJI AI module is not loaded. Please open the WUJI AI plug-in on the editor end or execute await w.ai.init() first to initialize the module.",
    "k_8d2b8169": "This deployment version does not support switching accounts. Please contact the platform operation and maintenance personnel",
    "k_f62445c2": "The function of switching accounts is only available under the product terminal (custom domain name)",
    "k_a8a0bff1": "Global pop-up window {arg_0} does not exist",
    "k_d4e420d": "Application LessCode execution failed. Please verify the application-level LessCode code",
    "k_54c8eb8e": "Current page LessCode",
    "k_7af0f1ca": "Pop-up window on current page",
    "k_56521be0": "Global pop-up window",
    "k_8c4cf301": "Configured",
    "k_925cf2f1": "Bidirectionally binding data",
    "k_dd1ad259": "Binding to {arg_0} ",
    "k_7fe59327": "Unbind",
    "k_6634d0ee": "Add two-way binding",
    "k_1c3a2997": "Add parameters",
    "k_2d3f59e5": "Please write the body in json format (if you use an interpolation expression, the interpolation expression also needs to be enclosed in double quotes)",
    "k_61aa6432": "Add headers",
    "k_6442f789": "Add Query",
    "k_77bc86a6": "No robot, click to go",
    "k_39cbb313": "Failed to get list",
    "k_3842dc50": "No email configuration, click Go",
    "k_2a65347b": "Query (url parameter)",
    "k_9fd5fc78": "Body (post package)",
    "k_8a4fa7e2": "Please enter an object in JSON format",
    "k_f6a1ed55": "If you want dynamic binding, use the {{}} symbol, eg: {{ state.foobar }}",
    "k_f3124961": "Return value",
    "k_56cdf72a": "Output structure",
    "k_ed9a0638": "The return value of this method is returned by a custom method",
    "k_d9c2c95f": "View custom codes",
    "k_7598fa6a": "Method has no return value",
    "k_2cd6f5fd": "No parameter is passed",
    "k_26ccb713": "Using default parameters",
    "k_dcf80ab9": "Form parameter transfer",
    "k_5ef529ac": "Javascript parameter transfer",
    "k_9c9d4d10": "Edit the method",
    "k_58c9473d": "Data source method",
    "k_4fc7cedc": "If you want to customize parameters, you can switch to [Form Parameter Transfer] or [javascript Parameter Transfer] for configuration.",
    "k_8bec7ece": "* For querying data, the parameters are relatively fixed, so [Form Parameter Transfer] is recommended.",
    "k_7204597e": "*\n        The calls or parameters of interfaces such as create/update are relatively complex, so it is recommended to [javascript parameter passing]",
    "k_b88bade9": "Which data sources",
    "k_32a7471d": "Which {arg_0}",
    "k_9b026908": "Enterprise WeChat name",
    "k_8f3e651a": "Robot documentation and internal customer service documentation",
    "k_3b5c4691": "Enterprise WeChat Personal (Fixed)",
    "k_a8fcb588": "Enterprise WeChat Personal (Dynamic)",
    "k_963e4e05": "Enterprise WeChat customer service",
    "k_efbd6214": "Listing",
    "k_af95f247": "Fetch field",
    "k_5801ccce": "Support nested values eg: a.b ;a[0].b",
    "k_ddf83ed": "Column width",
    "k_93411675": "Enter the number of characters to display",
    "k_7cb8d8e6": "Drag to adjust the order",
    "k_685725c0": "Unable to find the corresponding DataStub through [{arg_0}]",
    "k_3d9077d9": "Whether to overwrite existing field structures",
    "k_2659b38c": "No valid fields found",
    "k_4db590d6": "Select the exported data structure",
    "k_c6d6321c": "Failed to obtain cos list",
    "k_945cd5f0": "Launched",
    "k_66897280": "COS barrel",
    "k_f98b656f": "Failed to obtain environment",
    "k_72209108": "Failed to obtain cos bucket",
    "k_752e0ee": "Whether to also use the data of [{arg_0}] as data exported by Excel",
    "k_236e3692": "Use",
    "k_f7e3218e": "Not use",
    "k_f1d01f7a": "Click here to view how to use it",
    "k_3e2bff02": "Derived modes",
    "k_86c0ee0c": "Single worksheet",
    "k_fbc35e98": "Multiple worksheet",
    "k_eeaec374": "Data derived",
    "k_8de077c8": "1. Use the page variable eg: data.yourSource.listData \n2. Use the execution result of the previous process eg: flowState.res.listData",
    "k_71b5879c": "Export field configuration",
    "k_9d05f1a7": "Configuration Mode (Fixed Column)",
    "k_f1b2274f": "Code pattern (dynamic column)",
    "k_afca030b": "Using template parameters",
    "k_ab3e2fe": "Calculate exported table configuration",
    "k_68e3ed73": "Table name",
    "k_f896aba3": "Supported formats",
    "k_63f6085a": "Do not destroy when closed",
    "k_1f6adbcc": "Instance ID",
    "k_97c79ad8": "This id is used to distinguish instances when opening multiple global pop-up instances that are not destroyed",
    "k_932ce511": "UI interaction",
    "k_f5254608": "Logic",
    "k_7b36b47a": "Import and export",
    "k_ff744567": "Page navigation",
    "k_3960fc20": "Draft",
    "k_4c349cd3": "External notification",
    "k_cecdb728": "Flow",
    "k_2862e786": "AI behavior",
    "k_5a006242": "Return parameters (received in the pop-up action)",
    "k_20a7ae71": "Copywriting",
    "k_c24d22cd": "Please set up a copy",
    "k_aa889a09": "No icon",
    "k_a80ac70b": "Width (optional)",
    "k_53bbde8f": "Example: 300px",
    "k_3a49de55": "Copywriting (support HTML)",
    "k_d312931f": "Do you really need to perform the operation?",
    "k_97105ad3": "Select \"No\" to terminate the process",
    "k_6b16c907": "OK button text",
    "k_c60fa5d0": "Cancel button text",
    "k_9ed6bbd6": "User confirmation results",
    "k_ebe72edb": "Prompt type",
    "k_c3cfc45f": "Prompt duration",
    "k_6426c44": "Whether it is a synchronization prompt",
    "k_f9f2ba58": "Please set content",
    "k_ca6b5c1f": "Ejected position",
    "k_7485784b": "Top left",
    "k_d55d16f8": "Top right",
    "k_cf7162dc": "Bottom left",
    "k_3d093e98": "Lower right",
    "k_373379db": "Please set the notification content",
    "k_7803dae9": "Prompt message",
    "k_20f56626": "Please enter something:",
    "k_ba45e89f": "Default value",
    "k_986b06a6": "Cryptographic pattern",
    "k_8c33a6ff": "Input box mode",
    "k_fd24931": "Single line of text",
    "k_2c43a2e9": "Multiline text",
    "k_cbaddf0a": "Password",
    "k_6eb9032f": "Terminate the process if \"Cancel\" is selected (otherwise the default value will be used)",
    "k_a6cef13b": "User-entered text",
    "k_6b381d6": "After the pop-up window is closed, perform the next steps",
    "k_88ec7b8b": "Select pop-up window",
    "k_bc4829c5": "Global pop-up settings",
    "k_92f695df": "Pop-up window parameters (parameters in the pop-up window can be obtained through props.xxx)",
    "k_e1d734d2": "Return value of pop-up window closing behavior",
    "k_8827f9cc": "Please press the keyboard",
    "k_4feb17b1": "To paste content",
    "k_fe0b5061": "Unpaste",
    "k_4167191d": "Trigger page slice event",
    "k_6c4d3ff3": "Externally you can get the event parameters XXX given here through `$event.XXX`",
    "k_e86f3a8f": "Trigger event name",
    "k_230b1765": "Selection event",
    "k_39c61fb2": "Trigger page slice event [pagelet:emitEvent]: Event must be selected",
    "k_29468fa1": "Three-way merger",
    "k_217525ad": "The content of the two versions can be compared and merged based on the benchmark version",
    "k_215f06fc": "Reference content",
    "k_bebf07a7": "Remote content",
    "k_35121f81": "Current content",
    "k_6fbaf5d7": "Prompt for merge results",
    "k_2452e775": "The result of the merger",
    "k_f18f16b8": "Merge failed {arg_0}",
    "k_fd314ad8": "Copy content",
    "k_fa3e9dc4": "Whether to prompt for successful replication",
    "k_e7624279": "Replicate successful",
    "k_ea9668c3": "Call the LessCode method",
    "k_6c4a4a7": "Supports the called method of async. Wait until completion before performing subsequent steps.",
    "k_136b2e90": "Method name",
    "k_668dcab": "Terminates the process if the method returns false",
    "k_132f3e5c": "If you need to use variables or expressions, use double curly braces",
    "k_ac5168de": "Return result of the called function",
    "k_2742a48a": "{arg_0} method not found",
    "k_6df3c2fa": "Some debugging information of the current step will be output on the Console, and you need to cooperate with the browser DevTools to view it.",
    "k_461604b1": "Online components send events",
    "k_16369f69": "Throw events from this online component",
    "k_b641daa8": "Event Key",
    "k_179d8e4a": "The return value here is passed as an event parameter to the page that uses this online component",
    "k_b78a92ae": "Parameter description",
    "k_27d07796": "Whether to prompt the user",
    "k_aad473bc": "Specified namespace",
    "k_58030b7e": "Used when business needs to be differentiated. When not specified, the draft will be used on the current page or pop-up window by default",
    "k_9c9e78ba": "Do you want to save the current draft?",
    "k_3f4f470": "Save",
    "k_e51e6ef4": "Whether to keep the draft after the user cancels the recovery of the draft",
    "k_bd606fe9": "Do you want to restore the last edit?",
    "k_8ce1e294": "Recovery",
    "k_5d6990a5": "If you specify a namespace for saving the draft, you need to enter the corresponding namespace",
    "k_bd07b32b": "Call the data source interface",
    "k_ec59b262": "Call the data source interface and return the interface call result. Batch calls are supported (note that this step will not update page data)",
    "k_409f979f": "[Call data source interface]{arg_0} interface cannot be found",
    "k_1fff1378": "[Data Source Request] parse db body fail",
    "k_d51661c7": "Return to inclusion",
    "k_c9e1a874": "Error object (if any)",
    "k_5e33e7e7": "Batch call data source interfaces",
    "k_8d8070e0": "Calling the data source interface in batches and returning the interface call result is different from the front-end batch in 'Calling Data Source Interface', where the batch here is the back-end batch of a single interface. Currently only DB data sources support this operation",
    "k_23853ce8": "Which data source, value format: data. {sourceId}.$ methods, where sourceId must be obtained through the Information command",
    "k_f508bc5": "The method ID of the data source is obtained through the Information command.",
    "k_c199ae21": "Data source {arg_0} does not exist",
    "k_9eb9d1d2": "Data source {arg_0} has no method named {arg_1}",
    "k_4ec7a197": "This behavior calls the initialization (init) methods of all data sources in batches concurrently",
    "k_b7768b6c": "CosID{arg_0} does not exist",
    "k_75d6d562": "Failed to obtain cos authentication: {arg_0}",
    "k_eec9fca9": "Failed to initialize cos instance",
    "k_8120aba": "Unknown error",
    "k_139ed9ba": "Export failed: {arg_0}",
    "k_8def6363": "Support export of files in xlsx, xlsm, csv (single sheet) formats",
    "k_2effff72": "Configuration mode",
    "k_19de9bca": "Field configuration",
    "k_c7c908fe": "Dynamic field configuration",
    "k_93910646": "The csv format does not support multiple sheet export",
    "k_e15c599f": "Exported successfully",
    "k_bcc6464": "[excel export] The target data is not an array",
    "k_b75e711d": "[excel export] Invalid field configuration",
    "k_2e2bfd56": "[excel export]{arg_0}",
    "k_fc362b96": "Next steps can be accessed through `flowState.__ file__`Gets the imported file object",
    "k_558e2802": "Raw data",
    "k_3c1ac1e4": "Output date type as Date",
    "k_9d343e75": "Current sheet data",
    "k_ab2fd52": "Current row data",
    "k_675524a": "Data imported by excel",
    "k_4c6e5af6": "Only support extracting text file data\nSuch as JSON/CSV/SQL/plain text files",
    "k_bcf42508": "Whether multiple selection is supported",
    "k_6e046da0": "Whether to support selecting folders",
    "k_6808e00c": "Not support the file type",
    "k_a4ab74ec": "File extraction error {arg_0}",
    "k_86a61cad": "File data",
    "k_2683fbfa": "File object",
    "k_75eba9b0": "Multi-environment configuration (this is not required if you do not need to distinguish between environments)",
    "k_8fa91e29": "File",
    "k_5ed30431": "Upload path",
    "k_ab62831f": "Upload header",
    "k_2ab4858f": "The header key needs to be in standard writing, such as Content-Type",
    "k_39e5732a": "Upload file path",
    "k_8a717ba0": "Upload to COS failed, invalid file or COS bucket configuration",
    "k_7fdf389": "Scroll failed, component for {arg_0} could not be found",
    "k_e6d681e1": "Top",
    "k_e20c63be": "Bottom",
    "k_43368a95": "Specified location",
    "k_b00dff6": "Specified component",
    "k_b0e1bf8a": "Vertical axis position (unit: px)",
    "k_f69a92ff": "Component offset value (unit: px)",
    "k_4adfec41": "Instantly",
    "k_bff2dc8a": "Smooth",
    "k_15980a00": "Page query parameters",
    "k_38a133a4": "Page params parameter (replaces dynamic parameters in page path)",
    "k_abb410c9": "New window opens",
    "k_50e3b7e2": "Jump method",
    "k_9866df8a": "Push (history adds new record)",
    "k_713c4b44": "Replace (history does not add new records)",
    "k_73f40a65": "Jump failed, invalid page path",
    "k_463d4473": "Open: {arg_0}",
    "k_6ecc6f31": "Invalid jump link",
    "k_679d8bd4": "Whether to return to the previous page",
    "k_a04eeb3a": "Email delivery failed",
    "k_564045b4": "Enterprise WeChat notification failed",
    "k_cb0c139c": "Enterprise WeChat customer account notification failed",
    "k_aeeddca": "Sender",
    "k_f9ea78a5": "Recipient",
    "k_902196d0": "CC",
    "k_9e1be7d3": "BCC",
    "k_646011a0": "Message subject",
    "k_950eed59": "Recipient, subject or content is empty, please check",
    "k_df6b2766": "For more information on the message format, please [click to view](https://developer.work.weixin.qq.com/document/path/95274)",
    "k_6b0143be": "Robot",
    "k_452499c5": "Message",
    "k_d212955": "Success notification",
    "k_ce9f22e9": "Robot notification configuration error",
    "k_f61dfa4a": "Robot messages should be valid JSON",
    "k_858a290e": "Robot notification was successful",
    "k_78a10542": "Robot notification failed",
    "k_f34627de": "Notification settings",
    "k_41e79eab": "Notification application (message sender)",
    "k_fdbedf8": "Message recipient type",
    "k_8bb652da": "Message recipient",
    "k_ff841d1f": "Message type",
    "k_d663218e": "Link",
    "k_9c4c9dc": "Button text",
    "k_64babb9a": "Details",
    "k_ca02b77d": "Enterprise WeChat notification-Message recipient cannot be blank",
    "k_20ded012": "Enterprise WeChat notification-text content cannot be blank",
    "k_acf52c6b": "Enterprise WeChat notification-Markdown content cannot be blank",
    "k_edaaf97e": "Enterprise WeChat notification-text card message configuration is incorrect",
    "k_1ec66a3b": "Enterprise WeChat notification was successful",
    "k_d700b76b": "Arouse configuration",
    "k_8e926d67": "Enterprise WeChat name (dynamic)",
    "k_d7d9aaf": "Customer Service Number (uin)",
    "k_f72d031f": "Enterprise WeChat name cannot be blank",
    "k_93e4c99f": "Enterprise WeChat customer service account cannot be empty",
    "k_d82e437e": "Invalid data id created",
    "k_23443dd8": "No corresponding e-flow configuration found",
    "k_ccba562e": "Refresh data",
    "k_26b9f0c6": "(Old version) Repulling data from the data source",
    "k_f914ae3f": "(Old version) Submit changes to the data source",
    "k_fda52c45": "Behavior type",
    "k_985c95cf": "Automatic (create/update)",
    "k_2c8cc473": "[Single Mode] Create",
    "k_c685108e": "[Single Mode] Update",
    "k_2e5eae47": "[Single Mode] Delete",
    "k_9ef16ebb": "[List Mode] Update list",
    "k_c9929d84": "After the operation is complete, reload the form data",
    "k_da5a3292": "Operation failed: (Error code {arg_0}){arg_1}",
    "k_cad5b4b8": "Operation failed",
    "k_4d88f459": "Data source operation results (in creation mode, objects of the type { \"id\": xxxx })",
    "k_b656efee": "(Ancient version) Approval rejected",
    "k_68eaf671": "(Ancient Version) Approval",
    "k_f1f77303": "(Ancient Version) Launch Process",
    "k_4b3481f5": "New object ID",
    "k_cf416f03": "Approval (Obsolete)",
    "k_53ade266": "Process instance ID",
    "k_80a4f7e5": "Current state",
    "k_826df261": "Process instance ID cannot be empty",
    "k_b0c83858": "Approval failed {arg_0}",
    "k_f5518bdb": "Approval rejected (scrapped)",
    "k_b9bcd6a6": "Send HTTP requests",
    "k_7a38e68f": "* All of the above input boxes support filling in interpolation expressions",
    "k_9ca32af": "Request method",
    "k_ac34c87b": "Request whether to bring cookies",
    "k_98d15e06": "Timeout (milliseconds)",
    "k_28a6c177": "Prompt copy of request failure",
    "k_b9b9f0a8": "Request response results",
    "k_bd6a4749": "Request failed {arg_0}",
    "k_d62e0465": "Data source operation (deprecation)",
    "k_6f1dedb": "Reset the form",
    "k_4db936aa": "Submit list modification",
    "k_70210d79": "(Automatic) Create or modify current data",
    "k_d1333a89": "New data",
    "k_746cf9c7": "Modify current data",
    "k_2306be16": "Delete current data",
    "k_1eb5601b": "Data source {arg_0} failed to load data: {arg_1}",
    "k_880fed03": "Data source {arg_0} failed to load data:",
    "k_46049079": "Submitted",
    "k_e1574ccc": "Modification submitted",
    "k_51790c4d": "Are you sure you want to delete it?",
    "k_8a731d2a": "Deleted",
    "k_81385ec6": "[Delete] button",
    "k_fe771102": "[Submit Modification] button",
    "k_33cdee69": "The data source {arg_0} is configured with pageCon.filter, as well as filterCon. The former has been abandoned",
    "k_21a38a3c": "Currently not in edit mode, please check the program",
    "k_6a4d2a98": "[Error initializing data source {arg_0}]{arg_1}",
    "k_1c4318b0": "[Error initializing data source {arg_0}]",
    "k_151c8588": "Initiation request",
    "k_66cbb9fe": "{arg_0} Request",
    "k_d195a613": "Complete form",
    "k_9d4a9653": "Create mode",
    "k_4d81e17": "Edit mode",
    "k_732987b6": "Create",
    "k_9597d9dc": "Regular expression for mismatch fields: {arg_0}",
    "k_8ec7fb96": "Please use the Component Library Panel-Data Source to find the fields you need",
    "k_6fedc048": "Manage data sources",
    "k_f29d33ce": "Add a data source",
    "k_4eb4c0b1": "Import fields from a data source...",
    "k_832868a7": "Currently, there is something in your form, and switching data sources will lose the original content. Continue?",
    "k_28300e9f": "This data source cannot be imported. Please drag and drop the \"Data Source\" on the left to create a form.",
    "k_55c394fd": "To create a form, add a data source first",
    "k_a9ea92d4": "Please select a data source to generate the form?",
    "k_e6065cb0": "Use a blank form",
    "k_2b9375a4": "The operation failed. The form cannot be generated for {arg_0}. Please contact the platform for feedback.",
    "k_d252758f": "Form",
    "k_48981cad": "Data field",
    "k_cc4dfd38": "This component is recommended based on the data table structure",
    "k_5c3d1497": "Read-only field, please bind data",
    "k_b0808e9b": "Title The Title",
    "k_2608ee83": "Subtitles can be deleted if not needed",
    "k_c63574bc": "Here are some introductory words... Please note modification, or bind to existing fields of the data item",
    "k_dfdb705b": "Additional copy can be deleted if you don't need it.",
    "k_292a39c5": "A button",
    "k_7c5b509a": "Button 1",
    "k_b732fdaf": "Button 2",
    "k_1f3e8d07": "Detail card",
    "k_cf1fdba4": "Picture card",
    "k_381f690b": "List card",
    "k_f5f35e47": "Data source log",
    "k_c37894be": "Data source operations (old version)",
    "k_e660b89": "Form type",
    "k_db9a6f98": "Labeled form",
    "k_dfa0dd9": "The tagged",
    "k_6871664a": "Bidirectionally binding",
    "k_80f3b0da": "Please define $query in the Data Source-> URL parameter. {arg_0} and turn on bidirectional binding to modify query",
    "k_f7bae376": "URL parameter",
    "k_d462acc0": "Data source dependence",
    "k_d0e41c20": "Simulated routing dynamic parameters",
    "k_919e39d6": "Parameters passed to pop-up window",
    "k_a6769979": "Parameters passed to page slices",
    "k_56fe2f6c": "Extension list",
    "k_26b26449": "Extension list floating layer",
    "k_4f39dc1f": "Disable",
    "k_975011de": "Enabled",
    "k_f7e87aaa": "Full-app",
    "k_d828db0e": "Current page",
    "k_945221f2": "Do you want to enable it for all applications or only on the current page?",
    "k_3d6dae32": "There are no extensions yet~",
    "k_392ef241": "[Refresh Process] button",
    "k_b5a6f668": "System built-in",
    "k_b729fdd7": "Current process",
    "k_44b560ad": "Flowsheet title",
    "k_9381362e": "State",
    "k_33d28a3d": "Initiation-time parameters",
    "k_ea69e7ef": "Global variables",
    "k_f6148a12": "Data for each node",
    "k_fa8ec205": "Process status description",
    "k_c279a045": "Current approver",
    "k_36dc214a": "Pay close attention to people",
    "k_1562a2e0": "Flowsheet website",
    "k_88d94282": "Block of process page",
    "k_b4fb734e": "Block header",
    "k_e80e44f6": "Time",
    "k_7dde8972": "Corresponding step node ID",
    "k_c7a47147": "Corresponding step node type",
    "k_72c30a28": "Refresh page data",
    "k_33da2838": "Waiting for the next area",
    "k_eb6cec41": "Block loading failed:",
    "k_e2e1a99a": "Place the form here",
    "k_2e3e2c4f": "Page slices of process nodes",
    "k_7f5b428d": "To configure the page, please operate directly on the left",
    "k_820f76c6": "To configure data source events, please use the top [Behavior] panel",
    "k_e80a8160": "This is the default block",
    "k_b25b8862": "Break it up for editing",
    "k_99ed33f5": "Note: After breaking up, if you add new parameters during process design, there will not be automatic synchronization here!",
    "k_f88f8663": "Default page slice content",
    "k_3cb1dbe3": "This whole is the default form block and is automatically generated based on process configuration",
    "k_e700dbeb": "If you need to edit the interior, please click the \"Break up\" button",
    "k_3e60674e": "Scattered",
    "k_e3817a4e": "If you just want to add some explanations and legends, it is not recommended to break them up-just put what you want to show above/below/to the right of the block",
    "k_cd628148": "Process: {arg_0} ",
    "k_77fe6ac4": "Data authorization",
    "k_565a8431": "Mock: Process initiation page",
    "k_785015e3": "Open the process details page. {arg_0}",
    "k_fadfd038": "Process Launch Page",
    "k_4f8f39b2": "Data: {arg_0} ",
    "k_3dfef779": "The process editor is open. Remember to keep both sides",
    "k_a408a449": "To design the process",
    "k_9d008cf4": "Reset block",
    "k_21a398de": "Default navigation",
    "k_49bbfe3d": "Default menu",
    "k_b8e13dae": "No",
    "k_13bc5f1d": "Failed to obtain page tag list:{arg_0}",
    "k_b10c4baf": "Failed to create label: {arg_0}",
    "k_d1ab8b07": "Failed to delete label:{arg_0}",
    "k_7976dccb": "Failed to update label:{arg_0}",
    "k_3764454c": "Enter Save",
    "k_63a265fd": "New label",
    "k_e4aac70c": "Label name cannot be empty",
    "k_3c51fdef": "Creating duplicate tag names is not allowed",
    "k_9c96e49f": "Applicant",
    "k_f69403f5": "Application time",
    "k_e9becb72": "Application configuration modifications have not been saved. Do you need to save and jump?",
    "k_3c521f89": "Without saving",
    "k_d08e2a04": "Process configuration",
    "k_a26549c9": "All",
    "k_beb157fe": "In the examination and approval",
    "k_7d27843f": "Already through the",
    "k_a4640b30": "Had rejected",
    "k_227d6ef6": "Rejected / Workflow failed",
    "k_c692acb4": "Search",
    "k_4e2676db": "Basic approval",
    "k_9f607cb7": "Advanced Approval",
    "k_3b1a251e": "Agree with the selection ( {arg_0} ) ",
    "k_1a164baa": "Reject the selected ( {arg_0} ) ",
    "k_4112a5d9": "Preview",
    "k_cf8cccf9": "Current node",
    "k_557de6d3": "Revoked (abort)",
    "k_8493b107": "The revoked",
    "k_64f650a2": "Unknown state",
    "k_ca0be6f7": "A total of {arg_0} pieces of data",
    "k_29d5a22d": "Pending approval",
    "k_e1acdad0": "My application",
    "k_ee0e8193": "Approved",
    "k_36cc3223": "Relevant approval",
    "k_354a100f": "All approval",
    "k_5075404c": "Permission application",
    "k_bef02fc6": "Release approval",
    "k_7b3dba83": "Failed to obtain process configuration list",
    "k_3c8705cb": "Failed to obtain process instance",
    "k_8d055376": "Batch approval confirmation",
    "k_69cfcf4c": "Confirm the {arg_1} process orders that {arg_0} have been selected?",
    "k_184305b3": "Confirm {arg_0}",
    "k_e10b504d": "Batch approval was successful",
    "k_6a290277": "Batch approval failed",
    "k_c1fab51e": "Batch approval was processed, but some workflows failed",
    "k_92b5434d": "Failed to obtain process configuration",
    "k_6a1786be": "Built-in page permissions",
    "k_88a141db": "Customize page permissions",
    "k_e73156ed": "Unrelated",
    "k_d7ae1934": "Please enter the page name or path to search",
    "k_1e0fdae0": "Page label filtering",
    "k_17bfa636": "Overview",
    "k_25ddb22b": "Page view",
    "k_ef59f997": "Authorization ID",
    "k_bbfd0426": "Authority name",
    "k_b20393ca": "Hold authority",
    "k_858aa2": "Please enter permission name to search",
    "k_2cb77faf": "Batch authorize all pages in the application and use them with caution",
    "k_1091a552": "Please enter {arg_0} to search",
    "k_c7ff41cd": "New permissions: {arg_0}",
    "k_cb52390a": "Permission deleted: {arg_0}",
    "k_ac447102": "Role permissions have been added",
    "k_bb4f0f51": "Role permissions have been deleted",
    "k_1c9572f8": "Update failed",
    "k_88590c3": "Page permissions",
    "k_e865cd7": "Process authority",
    "k_fb041422": "Custom interface/collection permissions",
    "k_16ea7c75": "Built-in permission",
    "k_7513f654": "1 day",
    "k_f734062a": "3 days",
    "k_131310c7": "1 month",
    "k_bfd19c35": "3 months",
    "k_9d176e6b": "1 year",
    "k_eadabe83": "Permanent",
    "k_9b86e407": "{arg_0} is an {arg_1} employee\n      , valid for up to {arg_2} days",
    "k_d231a3d0": "Validity period",
    "k_81c27da2": "{arg_0} days",
    "k_74e84bf4": "Business",
    "k_acac53db": "Cloud Function Interface",
    "k_a3896355": "Application type",
    "k_c3253889": "Apply for page permissions",
    "k_db6346cf": "Apply for role",
    "k_c3ff1411": "Search no results",
    "k_ad31a0d5": "No roles available",
    "k_dfd14bd4": "Built-in roles cannot be applied",
    "k_60e41b61": "Context-based recommendations apply for the following roles",
    "k_7d445d30": "Please contact the administrator",
    "k_6c172fde": "Other roles (the following roles do not have permissions required by the context)",
    "k_73d54654": "Click to view role permissions:",
    "k_3f7e7eb4": "Application description",
    "k_79075b4f": "Describe the action in progress so that administrators can assign the appropriate role",
    "k_f56d22cf": "Additional Forms",
    "k_927e6858": "View application data",
    "k_11b2b861": "New Application Data",
    "k_c6fb6df9": "Updated application data",
    "k_9c7d76b4": "Delete application data",
    "k_556c0507": "View data",
    "k_55b9b537": "Update data",
    "k_17f2bda6": "Delete data",
    "k_6d1600bb": "View permission configuration",
    "k_85e85418": "Update permissions configuration",
    "k_11a23dba": "Upload in process",
    "k_d31fd601": "The role applied by the user does not exist",
    "k_a4da5574": "The role applied by the user does not have relevant permissions",
    "k_3df86315": "Obtaining permissions-Role failed",
    "k_2137271f": "Application role or page cannot be empty",
    "k_ba41f4a3": "Application description cannot be blank",
    "k_9e7792ce": "Failed to verify additional form, {arg_0}",
    "k_8e48113f": "Unable to find the approver, please contact the administrator",
    "k_9a892c89": "You can only select a maximum of 5 {arg_0}",
    "k_12dfe79b": "Approval authority application process",
    "k_1c76407b": "You are not one of the approvers and cannot approve; but the administrator can reassign",
    "k_fbcda0d0": "Please select or search for approvers",
    "k_5fa63f3c": "Assign approvers",
    "k_3c8f8c7e": "Please select an approver before assigning",
    "k_cc570dc7": "Assignment successful",
    "k_edb405d4": "Failed to assign approvers",
    "k_d1554fe": "Operation agreed, role cannot be empty",
    "k_f07c490a": "Approval failed",
    "k_481bdccc": "Approval Form Details",
    "k_6e523f39": "Revoked",
    "k_1adc5b73": "Approval retry",
    "k_9f61b23a": "Re-initiate approval",
    "k_8238b019": "The notification plug-in prohibits the default approval operation. Please approve the approval on the \"{arg_0}\" side ",
    "k_3035f068": "The document does not exist or is not authorized to access it",
    "k_477eef46": "Failed to obtain approval document",
    "k_f4382985": "Failed to obtain approval document record",
    "k_5e9ec25d": "Are you sure you want to cancel the current process order?",
    "k_be2f741e": "Description",
    "k_836a1c78": "Failed to cancel order, {arg_0}",
    "k_1faeb29a": "Determine the nodes that failed to retry the approval execution hook?",
    "k_556976ba": "The same approval operation will be re-executed on the failed node. If multiple hook interfaces are configured on the node, it will be executed again regardless of whether it has been successfully executed or failed before",
    "k_660dcfac": "Failed node: {arg_0}({arg_1})",
    "k_a4bea126": "Retry failed, {arg_0}",
    "k_601599de": "Re-initiating approval failed, {arg_0}",
    "k_b5a4f64e": "No approval configuration found",
    "k_12a3fd60": "Are you sure to re-initiate approval?",
    "k_ce306f0f": "It is detected that the current approval configuration is not associated with the initiation process page. The approval data cannot be modified. The original approval data will be used to initiate again.",
    "k_877783df": "Loading...",
    "k_ad04346b": "{{ state.pageTitle ||\"Process Example Details\" }}",
    "k_4f80e736": "Application",
    "k_651d8e10": "Return",
    "k_96aa130e": "Permission data environment is isolated, current environment: {arg_0}",
    "k_85fd4c96": "Initialization has not been completed, and management on the WUJI side is not supported yet. Please go to the Pangu side to manage the configuration yourself.",
    "k_7833783a": "Click to go to Pangu",
    "k_e14286c": "Custom rights management",
    "k_7cb8521": "Quick selection:",
    "k_eb0ffa9": "My Department",
    "k_709591a0": "My team",
    "k_7649b341": "Failed to add role ({arg_0}): {arg_1}",
    "k_7a4ef58a": "Saved",
    "k_f6594213": "Failed to add role",
    "k_7907628d": "Delete role failed",
    "k_3e84d0f6": "Are you sure to delete the role?",
    "k_e31c4c0a": "Role will be deleted:",
    "k_a8c335b2": "User already exists",
    "k_f7430466": "User",
    "k_9edd2518": "Organization",
    "k_80bbede4": "A business of",
    "k_a04a048e": "Platform",
    "k_c5ca71a": "Application Type Role",
    "k_df24a06c": "Associated roles",
    "k_56678614": "Add roles",
    "k_3613c3e7": "Click to display all (including expired ones)",
    "k_591f556d": "Switch business",
    "k_f24a3eaa": "Platform (business irrelevant)",
    "k_1ddbcd9b": "Application type role, business irrelevant",
    "k_b5d17cb6": "The third-party authentication",
    "k_92693add": "Platform Configuration-Runtime Custom Authentication",
    "k_1af095c3": "Failed to detect user rights",
    "k_57ae3ac7": "Pangu",
    "k_2721cd30": "Hold authority",
    "k_9abe0fa1": "🚫No authority",
    "k_94d935c0": "User has administrator status",
    "k_2a06b507": "The administrator identity may come from: the manager in the application information, the developer of the development environment, the member of the administrator role in rights management, or the manager of the application group, etc.",
    "k_1b025b35": "Authentication source",
    "k_3cde56a8": "Authentication result",
    "k_6179350d": "Detect user rights",
    "k_5542def7": "Please select",
    "k_6b30db70": "Relevant page",
    "k_771586f6": "Related business",
    "k_e0ecb787": "Choose to isolate business",
    "k_c9e3f880": "Detection",
    "k_d2f7f39c": "Platform (application type role)",
    "k_9a143067": "Expiration time",
    "k_15302aab": "Open-ended",
    "k_9ea6fc4": "All roles have been added",
    "k_d9d812e3": "Batch setting expiration time",
    "k_b2173608": "Due within days",
    "k_59eae679": "Has expired",
    "k_8f2599df": "Days",
    "k_b62b76f3": "Role type",
    "k_e0a0bc00": "Business isolation is not enabled",
    "k_8a91f80a": "For example: admin-group",
    "k_506e847d": "Example: Management Group",
    "k_5c1ee823": "Required",
    "k_367572ca": "Maximum length 36",
    "k_6381b181": "Valid characters: English letters, numbers, underscores and \"-\"",
    "k_15605837": "Role duplication",
    "k_a9ac2ed5": "Business cannot be blank",
    "k_be32bbaf": "Failed to add user ({arg_0}): {arg_1}",
    "k_12ef0f98": "Failed to add {arg_0}",
    "k_a4e6ed1c": "Failed to delete {arg_0}",
    "k_d1a100c8": "Are you sure you want to delete {arg_0}?",
    "k_e8019f3f": "{arg_0} will be deleted: ",
    "k_8b404cd2": "Current association {arg_0}",
    "k_8aeb6cd9": "Add {arg_0}",
    "k_c5ded26a": "Delete {arg_0}",
    "k_cc37f9a3": "Start synchronization",
    "k_1c32d762": "Synchronization",
    "k_67b79fe0": "Synchronization end",
    "k_dce7ec06": "Don't have permission to view the {arg_0} environment",
    "k_1bca45a4": "Failed to get {arg_0} list",
    "k_37dd0b49": "No right to update the target environment",
    "k_f602515f": "Synchronization failed",
    "k_62b0dd47": "Obtain",
    "k_5384ba5": "Interface binding permissions",
    "k_c121fec1": "Role permissions",
    "k_b36a7ea3": "Character user",
    "k_d2188f46": "Successful",
    "k_a4be3f9c": "Failed, or already exists",
    "k_22a5075": "Successfully synchronized permission configuration {arg_0}",
    "k_c7edc36d": "Failed to synchronize permission configuration {arg_0}",
    "k_54e5c418": "Successfully synchronized role configuration {arg_0}",
    "k_d9b8a867": "Failed to synchronize role configuration {arg_0}",
    "k_f527168f": "Permissions, interface relationships to which interface type permissions are bound, and collection related permissions will be synchronized",
    "k_967a19fc": "You can also synchronize through \"Sync Role Configuration\" with permissions",
    "k_fa9223ef": "The interface relationships of roles, permissions, role-permission bindings, and interface type permission bindings will be synchronized",
    "k_1c74311f": "Non-existing permissions will be created simultaneously to the target environment, but relevant pages or data sources should be published to the target environment by publishing the version yourself.",
    "k_763d3b0a": "Selection context",
    "k_63bbf1c7": "Permissions that require synchronization",
    "k_f8b0f20d": "Roles that need to be synchronized",
    "k_6a6baed3": "Sync to environment",
    "k_e2ca8af9": "Sync Role-User",
    "k_c4f2f5e4": "Existing users in the target environment will not be deleted",
    "k_b1ce8b48": "Synchronization results",
    "k_d267b42b": "View results",
    "k_79c6d62b": "Power authentication is not enabled in the target environment and cannot be synchronized",
    "k_cf6d8710": "The target environment does not have read-only mode enabled and cannot be synchronized",
    "k_4508397f": "Synchronization is successful",
    "k_a48a27a4": "Synchronizing, please wait",
    "k_2752769": "Sync permission configuration",
    "k_29c1d5f2": "Permission set",
    "k_5e2c6855": "- Invalid organization, organization ID or changed",
    "k_ea042cd3": "Are you sure to delete the current role?",
    "k_988201b7": "Note: All associated users will be deleted at the same time",
    "k_6118ed64": "Manage users/organizations",
    "k_5d2c15a5": "Automatic maintenance by the system",
    "k_840692fa": "The role is a business type, but the application does not enable business isolation",
    "k_bb419b65": "Add users",
    "k_c2a13176": "Delete user",
    "k_36902a80": "Not yet connected with Pangu Organization",
    "k_ab2a318f": "Add an organization",
    "k_e063159d": "Delete an organization",
    "k_cf2601eb": "Built-in roles",
    "k_4b6883f0": "Associated Users/Organizations",
    "k_96a82d76": "Unlogged visitors",
    "k_12f6d40a": "All logged in users",
    "k_8163e8ec": "All users",
    "k_49c11246": "Management Authority",
    "k_f27fc1d1": "Role locked",
    "k_21a6dc55": "Administrative role",
    "k_3debb283": "Modify role name",
    "k_febf41c1": "Permission with business isolation",
    "k_b21d1a08": "{arg_0} (Click to copy)",
    "k_832f8120": "{arg_0} has been copied",
    "k_a766ebf7": " permissions",
    "k_23d73def": " members",
    "k_ab7e00c7": "Failed to obtain role and permission information",
    "k_2802155d": "{arg_0} The environment has not been version released yet",
    "k_f69f1c55": "Application generation process was successful",
    "k_99bf2bd0": "Application generation process failed",
    "k_8dfabb10": "Are you sure to generate a custom application process?",
    "k_b4765ff6": "The permission application process is provided by the platform by default",
    "k_2b429fda": "After generating the custom application process, you can",
    "k_228b7004": "Modify the approver, and the default approver is the application administrator role",
    "k_32ecb2e": "Add your own application success hook",
    "k_6b5cf2cd": "If you do not have the above requirements, you can use the application process provided by the platform",
    "k_62b40ffd": "Confirmed",
    "k_505c7efb": "Synchronizing role configuration",
    "k_81ccf1c3": "Permission application settings",
    "k_b29e29fa": "Click to view",
    "k_b4c528a9": "Click to generate",
    "k_20f5996e": "Platform-level custom authentication is enabled, the configuration here is invalid",
    "k_5016f531": "Third-party authentication is enabled, configuration here is invalid",
    "k_6224331b": "No authorization to update, read-only mode",
    "k_a2fd9dd6": "Not have permission to view",
    "k_ac3c2a7e": "Search for roles",
    "k_5d1fdb0a": "Please enter the role ID or role name keyword",
    "k_b53e6a5d": "Edit role",
    "k_eeb40c47": "Manage {arg_0}",
    "k_6f08ec45": " - Non-development environment, read-only",
    "k_bd790946": "Permission application settings {arg_0}",
    "k_18212795": "The following configurations require release to take effect in other environments",
    "k_a9d5d5a4": "Customize the permission application process",
    "k_422a9045": "If not, use the built-in permission application process",
    "k_c7b54ff7": "Forbidden to apply for page permissions",
    "k_cf7f0d44": "If you apply for page viewing permissions, the platform will automatically generate the/page-path role. The permissions of this role only have the viewing permissions of the page and cannot be changed",
    "k_ee6711b2": "Apply for role model",
    "k_c3881116": "When users apply for multiple roles, should they be merged into one approval document or split into one role and one approval document?",
    "k_2952c591": "Combined",
    "k_868b8564": "Split",
    "k_f170ea29": "User/Organization Name",
    "k_f84e8c1b": "Expired disabled",
    "k_68f6ba4e": "In effect",
    "k_d835c796": "Expiration time",
    "k_3b810880": "Never expires",
    "k_5b99febb": "Expiration time set successfully",
    "k_eb75e1fe": "Failed to set expiration time",
    "k_312ec4": "Set expiration time",
    "k_d35f100a": "Is selected",
    "k_bf62315e": "One",
    "k_8d9ea3bf": "User or organization filtering",
    "k_c051292e": "Expires within 7 days",
    "k_2cf32537": "Expires within 30 days",
    "k_bb82dfb7": "Total {arg_0} items",
    "k_f4003f7d": "Are you sure to remove the current user/organization?",
    "k_b30ecd36": "Note: All associated roles will be deleted at the same time",
    "k_fe4c3f86": "Has been removed",
    "k_fb50bc50": "Edit",
    "k_50336413": "Remove {arg_0}",
    "k_46ae8222": "Batch update expiration time",
    "k_f49e8c60": "Please enter your name to search",
    "k_6df11f6c": "Click the top-right button or press Esc key to exit full-screen mode",
    "k_7a7edf9f": "Exit full screen",
    "k_c0e292d8": "Full screen",
    "k_56da1ba6": "Extended fields must be legal JSON strings",
    "k_446e6b00": "Extended field must be an object",
    "k_ce6969a7": "Extended fields cannot contain protected fields: {arg_0}",
    "k_b5937989": "Valid characters: English letters, numbers, underscores,\"/\" and \"-\"",
    "k_b494c015": "Duplicate permissions",
    "k_3b80d08c": "Maximum length 128",
    "k_4a4ffe": "Unique identification",
    "k_fd3353cc": "Extension field",
    "k_cf56c2b": "Permission type",
    "k_1124f650": "Permission name",
    "k_22bb085": "Associated page",
    "k_bf45c68a": "If you do not fill in, you will associate all pages",
    "k_9fe735f7": "Please select the associated page. If you do not fill it in, you can use it on all pages",
    "k_4e598ff3": "Failed to detect permissions",
    "k_61b4497e": "Role members",
    "k_e6e5601f": "Testing authority",
    "k_e39e29f1": "Are you sure to delete the current permissions?",
    "k_fc886eae": "Note: Bindings, such as role-permissions, interface-permissions, will also be deleted",
    "k_318e6052": "Manage joins",
    "k_970a22ed": "Data source interface",
    "k_a9439afa": "More",
    "k_86fd0a2e": "Modify permissions",
    "k_1612ef2e": "Are you sure you want to delete this interface association?",
    "k_295194b8": "Interface: {arg_0}",
    "k_f0a05caa": "Click X to delete the associated interface",
    "k_4777816a": "Associated cloud functions (",
    "k_c4b14d3e": "Associated data sources (",
    "k_820919a0": "Sync rights",
    "k_69b0a078": "Please enter permission name to search",
    "k_a4195300": "Edit permissions",
    "k_458ebfa7": "Manage cloud function interfaces",
    "k_9884f1e5": "Manage data source interfaces",
    "k_838046a2": "Already associated",
    "k_7eb6dd7c": "Correlated cloud function",
    "k_989b2cca": "Associated Data Source Interface",
    "k_57f2457d": "Binding success",
    "k_45422fa6": "Bind failed",
    "k_c381d36": "Binding permissions",
    "k_2d39d920": "Choice Privileges",
    "k_ac8ea015": "Unbinding successfully",
    "k_43f5dcff": "Unbinding failed",
    "k_f5fa441e": "Unbinding authority",
    "k_65eae92e": "Permission has been bound",
    "k_4ed64ded": "Select the permissions you need to unbind",
    "k_c0450c07": "Interface description",
    "k_f577e9b3": "No-",
    "k_8455430a": " Binding permissions",
    "k_e4a923d2": " Unbinding authority",
    "k_6be2405": "There is no permission control by default",
    "k_9d437070": "Remarks",
    "k_32686149": "Failed to obtain data source list",
    "k_2e882e3c": "\"{arg_0}\" permissions on the default binding page",
    "k_416999b9": "Failed to obtain binding list",
    "k_6aec0382": "Failed to obtain permission list",
    "k_cd41af47": "Enter the data source ID to search",
    "k_4bf257ee": "Enter the interface name to filter",
    "k_c6ee5945": "No permission",
    "k_aa33ccce": "You are not an application group administrator",
    "k_1283768d": "Please select the {arg_0} page",
    "k_b324687a": "{arg_0} page",
    "k_23261ba8": "Edit Data Table Page",
    "k_3d99548b": "Edit page information",
    "k_3310014e": "New page",
    "k_4a1dd98": "Copy page",
    "k_36624eac": "Default primary key",
    "k_a3d7608b": "{arg_0} Data source parsing failed. Please check the configuration of the authorization database",
    "k_7d79e4df": "Copy to clipboard: {arg_0}",
    "k_a397e39e": "The parameter format is incorrect and must be a JSON object",
    "k_9f49859a": "Parameters updated",
    "k_da0946ed": "Add missing default parameters:",
    "k_7083b8df": "Delete undefined parameters:",
    "k_f5d97150": "Unable to find process sheet with ID [{arg_0}]",
    "k_ad9271ca": "If it is not enabled, the debugging function of the node will be invalid, and the process after startup cannot be used as a debugging archive point",
    "k_ebec0b5e": "Debug mode",
    "k_cf0885d4": "Immediately launched",
    "k_85e973fe": "Reset",
    "k_61cc4716": "View Flowsheet",
    "k_cd6bb72b": "Import from recent processes",
    "k_ae400484": "Set process startup parameters",
    "k_ded4b1fc": "Flowsheet information",
    "k_62ae4e14": "Relevant approvers",
    "k_686301fd": "Process name",
    "k_cf9cd0fa": "Project ID",
    "k_6f0e8888": "Environment ID",
    "k_f7170f3e": "Process status (Chinese)",
    "k_ff8e2fee": "Process initiation page url",
    "k_81c2f47b": "Process version number",
    "k_c937df09": "Process messages",
    "k_3c5f9263": "Request information to initiate the process (headers and cookies)",
    "k_64a5d8c4": "HTTP request header when initiating the process",
    "k_1ebd304c": "The cookie object when initiating the process",
    "k_242a4446": "Creation time",
    "k_a8a5c92f": "Creator",
    "k_8468a7c8": "Modification time",
    "k_84424589": "Project information",
    "k_74d3cc0": "Project name",
    "k_7b67695d": "Format failed. Please check for syntax errors",
    "k_e3df4b6d": "Edit process configuration directly",
    "k_f60c46d5": "Process data cannot be found",
    "k_cc29b924": "Unable to find copied process data",
    "k_2235ca79": "Failed to obtain copied process data",
    "k_e1490b65": "Change detected, saving",
    "k_4fdf5117": "Process started",
    "k_5e146065": "Ask the assistant for details",
    "k_7d8fd189": "Began",
    "k_f9b5f40f": "End",
    "k_7e41426e": "System default",
    "k_f857b54e": "The new process must be saved before creating page slices",
    "k_7e87ddfc": "Failed to save page slice",
    "k_f6ab003f": "The page piece has been successfully created",
    "k_9269a45": "Page slice creation completed ",
    "k_47ce63fc": "Do you want to open a new edit page",
    "k_39ebf97f": "Go to the editor",
    "k_51b91241": "Save failed: {arg_0}",
    "k_88676045": "The approval plug-in has been successfully installed on the page piece",
    "k_60dab208": "Approval plug-in installation failed: {arg_0}",
    "k_2e01501": "Add page slices",
    "k_1e157ff9": "Edit page piece",
    "k_d12bdea3": "Other nodes of this process",
    "k_356c5124": "Other processes",
    "k_2d1f9a83": "This page slice was designed for node \"{arg_0}\" of this process. Please make sure the form fields and process params match",
    "k_6861e24": "The two nodes have different types ({arg_0} → {arg_1}). The \"current process node\" data structure used by the page slice is incompatible and most likely will not work",
    "k_43403f2e": "This page slice was designed for node \"{arg_1}\" of process \"{arg_0}\". Please make sure the form fields and process params match",
    "k_9781afb8": "Its process data grants were configured against the original process; values will be empty when field names differ",
    "k_51bf2f26": "{arg_1} data in {arg_0}",
    "k_b0fff121": "According to authority",
    "k_682cde83": "By role",
    "k_aa9703e4": "The user has one of the following permissions",
    "k_c14ba0ce": "The user is one of the following roles",
    "k_23af3c01": "Authentication",
    "k_141e46f5": "For example, the initiator job.creator or a specified user 'user_01', note the need for quotation marks",
    "k_c6525f5e": "Authentication configuration",
    "k_db9863ac": "Failure",
    "k_8a71f19f": "Added",
    "k_25cf2eb4": "Remove users from the following roles {arg_0} ",
    "k_c713dbd6": "Modify the configuration",
    "k_3753ac08": "Notification channels",
    "k_ed47e588": "Unknown notification plugin-",
    "k_b0a97ebd": "Push message",
    "k_cebc2630": "Output log",
    "k_d9e8a3e6": "Output",
    "k_b2f8ff7f": "Display on the details page",
    "k_a95f28e4": "The form displayed on the details page",
    "k_1f96704e": "After using custom page slices, you can design the appearance of the form and customize the front-end logic",
    "k_825a6006": "Enable notifications",
    "k_b29d481a": "Notifier",
    "k_b3410f3": "Notification configuration",
    "k_1dc8e8ec": "Condition judgment",
    "k_bda4d773": "Judgment condition",
    "k_8a42d7ea": "Determine whether the conditions are met",
    "k_71d3564c": "Is",
    "k_54a64727": "No",
    "k_1706d539": "Form to initiate the process",
    "k_548340d": "You can use \"page slices\" to customize the appearance of the form and customize the front-end logic of the initiation process",
    "k_3d2e011b": "After launching, hide it in the process sheet",
    "k_d7837f70": "Next step",
    "k_4d770db4": "DB data sources need to \"check response content\" to determine whether the read and write operation was successful",
    "k_8938f41": "Help me configure",
    "k_f178f052": "Edit data source",
    "k_8e36c985": "Select data source",
    "k_f78e0060": "Please select an interface",
    "k_c234e732": "After opening, request errors will not block the entire process, but will take the error handling branch",
    "k_a61675d5": "When something goes wrong, use custom bottom-up logic",
    "k_3fadf68b": "If your service response is to return a field in the body to identify whether it was successful, please turn on this function and tell us how to determine whether it was successful.",
    "k_73b298df": "The response content needs to be further checked to determine whether it was really successful",
    "k_effee207": "Judgment logic",
    "k_8adf95be": "Call data source",
    "k_f6c24a2": "Implementation",
    "k_6e71bb32": "Data source interface collection",
    "k_521169b3": "Get request parameters",
    "k_37129eae": "Enable error handling branches",
    "k_28eb3eef": "Custom judgment logic",
    "k_783bbd2a": "Request result",
    "k_75869484": "Including response headers, response data, etc.",
    "k_9deaf02e": "Return data",
    "k_8336c54d": "Back to head",
    "k_f509d599": "\n* * http ** type data source is unique.\n\n* * Note: You must go to \"Interface Information\">\"Transparent Response Header\" in the data source configuration to configure the response headers you need to obtain. **\n              ",
    "k_32227cc9": "Error message (when an error occurs)",
    "k_23f11d1b": "JavaScript calculation result in the \"Parameters\" section of the corresponding node configuration",
    "k_4230db11": "{arg_0} times remaining",
    "k_c8411d28": "The process level limit was exceeded by {arg_0} times! ",
    "k_562a94e5": "Regulation limiter",
    "k_b291195f": "Retry counter",
    "k_91e373e6": "Number of retries",
    "k_814e6299": "Note: You may need to configure the \"Maximum Number of Repeated Runs on a Single Node\" in the \"Process Details\"",
    "k_8c3820fe": "Retry interval (in seconds)",
    "k_53ddd97b": "Customize failure behavior",
    "k_b8e4e773": "If it is not checked, the entire process will be determined to have failed directly after the number of retries exceeds",
    "k_15dfc12d": "Time of first retry",
    "k_62adad09": "Remaining Retries",
    "k_5cb3bb44": "The time of each retry is recorded",
    "k_4c2a5f01": "How many retry",
    "k_d02940f4": "Start retry time",
    "k_b9fcd07e": "Are you sure you want to cancel the application of the associated database?",
    "k_956b208a": "Unapplying the database may affect the data sources of other pages. Please proceed with caution",
    "k_91521b88": "Table ID",
    "k_e53f25f0": "Full release",
    "k_504646e4": "Application publication",
    "k_e4ff5404": "Releasing services on a server in stages",
    "k_7296fb49": "Remove gray levels",
    "k_10c4405d": "Apply for rollback",
    "k_63f2ff1a": "Roll back grayscale",
    "k_149b5bd2": "Call version interface",
    "k_9e6baf1": "Configuration information",
    "k_3e423e67": "Table version",
    "k_cbf676a3": "Row version",
    "k_e0feb926": "Action",
    "k_91eda872": "Enable error handling branch",
    "k_7027df19": "After enabled, request errors will not block the entire process, but will take the error handling branch.",
    "k_558d0dff": "Results",
    "k_7863632c": "Response to calling version interface",
    "k_243ab7aa": "Initiate other processes",
    "k_abccc05b": "Process parameters (JS expressions)",
    "k_efd0f805": "Blank blank to use the initiator of the current process",
    "k_45d85616": "Wait for process execution to end",
    "k_b148121d": "If you do not check, the current process will continue directly after launching.\n\nWhether you wait or not, you can get the ID and URL of the initiated sub-process",
    "k_404c87c9": "(After initiation) Process Order ID",
    "k_48255a57": "(After launch) Process sheet page url",
    "k_dc69b9c3": "Actual process parameters (post-launch)",
    "k_62521600": "Field data authorization",
    "k_6ff22294": "The page can only access data authorized here. Please do not disclose sensitive data to visitors",
    "k_8980aaaa": "Copy job. {arg_0}",
    "k_9a6d8611": "Replicated: {arg_0}",
    "k_35aad5f8": "Updating authorization",
    "k_2c2f879c": "Please use the [Top Toolbar] to authorize process data",
    "k_a5921763": "Authorize...",
    "k_f1245ab2": "[FlowPagePlugin] Page slice refresh failed",
    "k_fb554f50": "Approval page capabilities",
    "k_32db480f": "Used to render advanced processes",
    "k_591fc75e": "Process node ID",
    "k_8c92bffb": "Current process node",
    "k_d059bee4": "Node ID",
    "k_27bc4c62": "WUJI AI plug-in",
    "k_d845ee90": "Deprecated and inactive",
    "k_fb9fec5a": "This plug-in is deprecated and inactive. Only disabling is supported",
    "k_5f57e1ec": "Failed to obtain plug-in list:{arg_0}",
    "k_2f8fbf1f": "Failed to execute extension {arg_0}:{arg_1}",
    "k_bd977f56": "Failed to obtain extension",
    "k_dafeb107": "No extensions available for debugging have been obtained yet:{arg_0}",
    "k_a38b4eaa": "Failed to obtain plug-in list",
    "k_983270d": "Local debug plug-ins do not support uninstallation",
    "k_4c99299a": "Failed to obtain application template list {arg_0}",
    "k_71fb6c9e": "Failed to obtain the list of customized application templates {arg_0}",
    "k_5311e214": "Failed to obtain application template {arg_0}:{arg_1}",
    "k_53b21aa": "Failed to get local draft: {arg_0}",
    "k_5d16a998": "Failed to get remote draft: {arg_0}",
    "k_4b1ce09b": "Failed to obtain modification record {arg_0}",
    "k_fc190338": "Module name cannot be empty",
    "k_50a6aaab": "Module names consist of letters, numbers, underscores, and dash lines, and can only start with letters and end with.js / .ts",
    "k_8c566698": "The module name already exists",
    "k_1893db7a": "Enter the module name ending in.js or.ts, and press Enter to confirm",
    "k_b1701ec2": "Failed to obtain modification record with id {arg_0}: {arg_1}",
    "k_792038cb": "Failed to get the list of modification records for type {arg_0}: {arg_1}",
    "k_45766415": "Failed to save modification record of type {arg_0}: {arg_1}",
    "k_db8fa218": "Default store",
    "k_8e4e6eb3": "Failed to obtain application list for application group",
    "k_e901db9d": "Failed to obtain component template list {arg_0}",
    "k_e4c77d2d": "Failed to obtain component template",
    "k_853fb3ad": "Template updated successfully",
    "k_b59111d3": "Template created successfully",
    "k_f5bb2eff": "Failed to obtain list of manageable component templates",
    "k_979fce5f": "Template deleted successfully",
    "k_912c9ac0": "Template deletion failed",
    "k_5714949e": "Base version",
    "k_d93e74f0": "Local version",
    "k_ceabce69": "Select incorporated version",
    "k_773d8833": "Select current version",
    "k_c855e813": "No content to merge",
    "k_b55c2cae": "Code merge failed",
    "k_529ef0ee": "Submission description cannot be empty",
    "k_30e49bab": "No changes were selected",
    "k_e3c8a6b5": "[{arg_0}] Data merge failed. Please check whether there are still unresolved conflicts",
    "k_89318787": "Submit a change",
    "k_cb3bc158": "Version release",
    "k_2f12b3e5": "Submit information (required)",
    "k_a83a6196": "Submitted",
    "k_757f8e09": "Code merge",
    "k_2a958058": "Code merge calculation, please wait patiently",
    "k_1b53325a": "Branch name cannot be empty",
    "k_b8fdcc77": "Failed to obtain branch list",
    "k_28718a38": "Failed to obtain branch information",
    "k_78c193e9": "Automatically switch to development branch",
    "k_931968db": "Failed to obtain the user's current development branch",
    "k_f1727d44": "Switch to the {arg_0} branch soon",
    "k_580147f2": "Failed to switch branch",
    "k_d1f925cf": "Failed to get uncommitted changes",
    "k_e76f0e39": "Failed to obtain submission record",
    "k_88e18551": "Failed to obtain latest version of branch",
    "k_1c675f24": "Pull",
    "k_1768046a": "There are no {arg_0} submissions",
    "k_9d30f28d": "Merge branches {arg_0} to {arg_1}",
    "k_9e5b90e": "Submitted successfully",
    "k_1a378776": "Submission failed",
    "k_c1fc01d2": "Reset commit operation failed",
    "k_19c27af2": "Failed to pull whether the application updates data:",
    "k_42b6f862": "Failed to pull whether the application updates data: {arg_0}",
    "k_78b196a9": "Failed to update application data:",
    "k_80303a7e": "Failed to update application data: {arg_0}",
    "k_aafffa70": "Failed to obtain project announcement list: {arg_0}",
    "k_efd4b918": "Announcement has been deleted",
    "k_7a29cb40": "Failed to delete announcement: {arg_0}",
    "k_38a75fb4": "Updated announcement",
    "k_56b62098": "Failed to update announcement: {arg_0}",
    "k_9eddd076": "Announcement created",
    "k_9680db30": "Failed to create announcement: {arg_0}",
    "k_3e3d2e52": "Failed to obtain project ticker announcement list: {arg_0}",
    "k_14ff5e3c": "Failed to modify read status: {arg_0}",
    "k_782fc1ea": "Failed to obtain data table list: {arg_0}",
    "k_dbed5abc": "Failed to pull material data: {arg_0}",
    "k_e216071d": "Failed to obtain announcement data",
    "k_e69577b9": "Failed to obtain announcement record",
    "k_da32f263": "The task failed. Please export again",
    "k_37f838ab": "Wait for the task export to complete...",
    "k_1d427ca9": "Download link is empty and cannot be downloaded",
    "k_d46fd381": "Ongoing",
    "k_cd21075e": "Failed to obtain offline list",
    "k_aef0b066": "Failed to obtain historical version number",
    "k_1d23083": "Offline task created successfully",
    "k_eaa3c7e2": "Offline task creation failed: {arg_0}",
    "k_e13b3a97": "Offline records have been deleted",
    "k_798309b1": "Failed to delete offline records: {arg_0}",
    "k_25d9ce9b": "Failed to obtain offline configuration list",
    "k_9ac58b33": "Offline configuration created successfully",
    "k_ab483881": "Offline configuration creation failed: {arg_0}",
    "k_3a097bcf": "Offline configuration update successfully",
    "k_8c0e0401": "Offline configuration update failed",
    "k_66babe8c": "Offline configuration update failed: {arg_0}",
    "k_5bf9626b": "Offline configuration has been deleted: {arg_0}",
    "k_bc2291a3": "Failed to delete offline configuration",
    "k_222dc84d": "Failed to delete offline configuration: {arg_0}",
    "k_f44c3046": "Configuration function debugging successfully",
    "k_55cbc7d2": "Configuration function debugging failed",
    "k_99a934d1": "Configuration function debugging failed: {arg_0}",
    "k_59996f07": "WUJI Default Skin",
    "k_3b186ae3": "The returned data is empty",
    "k_ae787d88": "Failure to obtain skin",
    "k_3e9f8ce9": "Failed to obtain skin data {arg_0}",
    "k_19909fc1": "Unable to get skin {arg_0}",
    "k_6bf8ff99": "Failed to get skin demo page",
    "k_6a865080": "Not authorized to call",
    "k_760521f2": "Do not have permission to initiate the process, click",
    "k_dfa53415": "Application authority",
    "k_bfacb6f4": "Open applications are not allowed to modify data, only allow data to be read",
    "k_7dd1a08e": "Request timeout",
    "k_754eb533": "Request failed: code={arg_0}, msg={arg_1}",
    "k_5b26cc4d": "The current login session has expired. Please login again.",
    "k_d5f24c87": "The current login session has been exited. Please log in again",
    "k_82f993d9": "Due to platform security policy update, please log in again",
    "k_44e3bc79": "It is detected that the login status has expired. Please log in again.",
    "k_ec984f07": "Login failed, please click login again",
    "k_26a3fe00": "Login status has expired",
    "k_eff6ad19": "Logged-in",
    "k_737f422d": "Log back in",
    "k_a59b2e2a": "Failed to obtain organizational structure information,{arg_0}",
    "k_92ea52af": "Reload the entire page",
    "k_dc205c89": "Editor is connected",
    "k_904adff5": "Connected editor",
    "k_3f1465e5": "Editor is not connected",
    "k_2f000ff": "Page configuration has been updated",
    "k_eeb8e00d": "Local refresh {arg_0}",
    "k_8d7fe155": "Refresh {arg_0}",
    "k_620e0233": "Template management",
    "k_cca20212": "Public account",
    "k_666ddcb": "Application group",
    "k_faccfaca": "Component Store",
    "k_e98a694f": "Authority center",
    "k_c74d09ac": "Use document",
    "k_a28e042b": "Data management",
    "k_5123ff8a": "Application management",
    "k_22d72976": "Failed to obtain application and page data: {arg_0}",
    "k_f4da8ef": "Currently in debug mode",
    "k_86cb51ae": "Path is not defined and cannot be previewed",
    "k_ec16344c": "Failed to pull the page list in debug mode. Please confirm whether local development services are enabled",
    "k_e6214383": "This page has no path configured and cannot be redirected",
    "k_e73e0041": "Simulation",
    "k_ae04823f": "Not logged in",
    "k_efae8637": "Personal information",
    "k_e4921fd6": "Key",
    "k_1c7700b9": "Acquire the key",
    "k_c2a5ce68": "Restore supervisor or operation and maintenance identity",
    "k_3f348d7": "Experience non-super management or operation and maintenance identity",
    "k_2abd22c6": "Failed to obtain key: {arg_0}",
    "k_8ea39b3e": "Copy key",
    "k_374559b9": "Get the secret key",
    "k_de69e180": "Copying failed! {arg_0}",
    "k_43f9cdd3": "Click to expand more",
    "k_a6cb1411": "Operation is not supported in preview mode",
    "k_256e835": "Environment name",
    "k_5a34c9cd": "Production environment",
    "k_6e9edec8": "Environment options cannot be empty",
    "k_c5cc7969": "Environment configuration has duplicate options '{arg_0}'",
    "k_2c3885e7": "Fast switching",
    "k_fdfa555f": "Failed to obtain application short path configuration",
    "k_739fe5ff": "Failed to delete short path configuration",
    "k_bbd94903": "This navigation group [{arg_0}] has no configuration page menu",
    "k_dffafaaa": "Failed to obtain approval list",
    "k_29ec9120": "Failed to obtain approval process",
    "k_9993c650": "Incorrect approval initiated",
    "k_5aa48296": "Approval page",
    "k_97f497d6": "You have {arg_0} pending approvals",
    "k_3b8a1d87": "Generating...",
    "k_4e6645fe": "The server has deserted, please regenerate the QR code",
    "k_b6db99ab": "Modifying pages",
    "k_626f1799": "Apply permissions",
    "k_b86ba482": "Permissions & Keys",
    "k_294ecaac": "My clearance",
    "k_c103f530": "New user registration approval",
    "k_e28b2f78": "Application Group Management",
    "k_2c8fe39a": "Restoring the administrator role",
    "k_b7722afb": "Experience non-administrator roles",
    "k_e59b454a": "Exit simulated login",
    "k_94412028": "Exit simulation",
    "k_91632073": "Failed to exit simulation, please retry",
    "k_85d5bda2": "WUJI 1.0",
    "k_356013f2": "Inherited from organization",
    "k_1cbd7c30": "Apply for renewal",
    "k_2d74feb9": "Click the role name to view detailed permissions",
    "k_393dc7ee": "Bulletin centre",
    "k_4fd6d239": "Expand to view details",
    "k_9dadcb05": "No announcement",
    "k_5870bbb8": "Know",
    "k_560ca57e": "Main menu switching",
    "k_4578bc06": "Powered by WUJI",
    "k_f51e95ca": "Sidebar.setCurrentGroup: Unable to find {arg_0} menu group",
    "k_d641f8b5": "Failed to obtain route from menu",
    "k_2bebc367": "You are experiencing a non-administrator role",
    "k_f2521368": "Informal settings",
    "k_80a48a8a": "Page {arg_0} ",
    "k_fad97a17": "Developer tools",
    "k_cbd2ed02": "Close other",
    "k_f80c5985": "Local cache",
    "k_21d16af2": "The page you are looking for does not seem to exist?",
    "k_201400b1": "Home",
    "k_299e1ad8": "Don't have permission to access",
    "k_94834e4b": "Please try",
    "k_9c9c4e1c": "Visit again later",
    "k_639d63e6": "Login",
    "k_3d9af866": "Note: Permission data environment isolation, current environment",
    "k_ba45a844": "Failed to verify permissions",
    "k_d5712fa0": "Failed to pull global variable configuration. Please confirm whether the local CLI service is started, or upgrade the CLI tool: {arg_0}",
    "k_bf58c1d8": "Unable to load the current page, missing page id definition",
    "k_5efa22f5": "A new version of the page has been released",
    "k_8e45119b": "You can click or refresh the page to experience it!🚀🚀🚀",
    "k_f6adc2b2": "[mock] Failed to obtain page data",
    "k_da8a7768": "[mock] Data saved successfully",
    "k_4dca5e38": "Mock data editing",
    "k_377c499d": "Mock title",
    "k_fd6ab5b2": "Slot",
    "k_66783720": "Event",
    "k_db6f2e39": "Component linkage method",
    "k_fa2ae7a2": "Unknown page {arg_0}",
    "k_f18bbba2": "Parameters within component- {arg_0}",
    "k_ecb3f718": "Please drag the component here",
    "k_465aa45a": "Data sources within component",
    "k_b48da60b": "Open the Component Editor",
    "k_50037619": "Open the edit page of this component",
    "k_ad53b5ff": "Don't prompt",
    "k_b9032647": "Please use the component in the page that opens",
    "k_f284640b": ", check the debugging results",
    "k_689bb658": "In this editor, clicking the save button (or pressing ctrl/cmd + s) will trigger an update of the debugging page",
    "k_c3a86ce7": "Please note: Do not refresh the debugging page, otherwise the hot update will be invalid.",
    "k_6889c4": "Failed to check permissions",
    "k_8070d3f3": "Component name",
    "k_a6a9cbde": "Number of leaks",
    "k_457fcad5": "Execution path",
    "k_80c0aaf2": "Query parameter tool",
    "k_8e6b702a": "Convert to filter array",
    "k_4efef7cc": "Option",
    "k_3c77f50b": "Convert to filter expression",
    "k_fdf548a5": "Convert to a nested filter expression",
    "k_e0a26c8": "Filter In nested format, and and or must be arrays",
    "k_d491d6bb": "In filter nested format, there can only be one and or on an object",
    "k_ebf1d54f": "Hook Key",
    "k_41c1d065": "Returned data",
    "k_25acabb2": "Received data",
    "k_e2e87955": "The URL to continue the flow. External systems can continue the flow by POSTing data to this address:\n`{arg_0}`",
    "k_b42ca206": "{\n  // You can return data to the caller as needed\n}",
    "k_2a8e5f76": "The latest commits of the target branch have already been merged",
    "k_b5b578ae": "Merge this branch into master",
    "k_d0f054ae": "This branch is {arg_0} versions behind master, click to pull",
    "k_b3e8a5e6": "This branch is behind master, click to pull",
    "k_5c34f680": "Check and merge the latest changes from master into this branch",
    "k_33583bab": "The latest commits of master have already been merged",
    "k_35e59479": "Failed to prepare the Git branch",
    "k_144747ef": "Continuing anyway may make Git-related features unavailable.",
    "k_50bff2d1": "Continue anyway",
    "k_aa961c28": "Failed to ensure Git branch readiness",
    "k_86ba09af": "Git is enabled, but no Git service URL is configured",
    "k_ba4736f4": "The Git service URL must use HTTPS",
    "k_6cbf94c6": "The Git branch readiness request timed out",
    "k_b5a15519": "Failed to reset the Git branch",
    "k_e0f18df9": "The Git branch reset request timed out",
    "k_974eac21": "Unable to connect to the Git service",
    "k_992e72e7": "Unable to get the current user private key",
    "k_52ce9cc4": "Unable to get the current user information",
    "k_9c348ec3": "No WeGit sync service URL is configured",
    "k_4f82688f": "The WeGit sync service URL must use HTTPS",
    "k_dbd13562": "WeGit sync failed",
    "k_4f35e556": "The WeGit sync service returned an unknown status",
    "k_1a2fb691": "Failed to load WeGit settings: {arg_0}",
    "k_bd8c2030": "Failed to save WeGit settings: {arg_0}",
    "k_4f3ee550": "Manually sync to WeGit?",
    "k_2918bfc6": "Syncing overwrites the corresponding WeGit branches with the current Wuji content. Confirm to continue.",
    "k_4a50089c": "Continue syncing",
    "k_e28fb664": "WeGit sync completed",
    "k_fd07df84": "WeGit sync failed: {arg_0}",
    "k_8e42464e": "Too many AI page code changes to display completely. Reduce the changes and try again.",
    "k_aadbb4b7": "The platform merge is complete. Finishing the container cleanup.",
    "k_8b8d5274": "The platform merge is complete. Retry the container cleanup before closing.",
    "k_ac38ec39": "Retry container cleanup",
    "k_b922647": "The platform merge is complete. Finish the container cleanup.",
    "k_e1c759ab": "Check the container connection and retry cleanup.",
    "k_2bcd2b98": "Back up any subsequent changes in the container editor, restore the workspace to the submitted revision {arg_0}, and retry cleanup once there are no uncommitted changes.",
    "k_805f6a3c": "Connecting to the remote merge session timed out. Please retry.",
    "k_13804d13": "Initializing the remote merge session timed out. Please retry.",
    "k_83084f4": "The merge is complete, but the translation scan reported issues: {arg_0}",
    "k_75845ea2": "The AI page revision returned by the platform does not match the container commit. Contact an administrator.",
    "k_d3f36bf0": "The current server version does not support container code merge. Upgrade the server first.",
    "k_9a43625": "Merge result",
    "k_4f3eedd": "Current",
    "k_eda9c0de": "Incoming",
    "k_1fa01337": "No sync records",
    "k_19370d0d": "Initialized",
    "k_1e665e34": "Synced",
    "k_1195ba1f": "Skipped",
    "k_8352b1dc": "WeGit settings",
    "k_e8479d08": "Enable WeGit",
    "k_553f5033": "Enable WeGit sync",
    "k_a85cb827": "After initial enablement, Wuji AI code is synced once to the bound WeGit repository; subsequent reads and writes use that repository directly.",
    "k_d99102e7": "Once enabled, Wuji project content can be synced to the bound WeGit repository.",
    "k_459d8db": "Repository address",
    "k_312d8383": "Sync status",
    "k_b22849b2": "Manual sync",
    "k_cbe5b13b": "Syncing to WeGit. Please wait.",
    "k_75722f1e": "Sync history",
    "k_a209c35a": "Sync ID",
    "k_da8d6624": "Operator",
    "k_51cf3d19": "Trigger",
    "k_4d41c22c": "Initial enable",
    "k_cf456c27": "Completed at",
    "k_5c8bf479": "Preparing the AI page code merge diff",
    "k_ca123c34": "Loading the AI page code merge diff",
    "k_e564523e": "The AI page code merge diff has not finished loading",
    "k_36b439b6": "More than {arg_0} files changed, so the complete diff cannot be displayed",
    "k_43b7368f": "Failed to start automatic merge",
    "k_a474a7f4": "AI page code conflicts need attention",
    "k_b3920d8b": "Review and submit the AI page code",
    "k_de4120c3": "The AI page code merge is incomplete",
    "k_94cfb250": "Open the container editor to review the merged code",
    "k_e51ac1d5": "Open the remote editor to resolve conflicts, or start a smart merge",
    "k_c2b9acec": "Open editor",
    "k_6380fd20": "Editor",
    "k_c6c95eb7": "Smart merge started",
    "k_1766393d": "Smart merge",
    "k_afba92f3": "Preview",
    "k_6eee9d96": "Automatically resolving AI page code conflicts",
    "k_ac06d6c7": "Preparing the AI page code merge",
    "k_41059e82": "Please wait, or open the container editor to view progress",
    "k_20dcd799": "Please wait, or open the remote editor to view live progress",
    "k_45315b7c": "View progress",
    "k_5e550a0d": "The AI page code diff is not ready",
    "k_9a73a125": "Starting automatic merge",
    "k_d63a8600": "Failed to start smart merge",
    "k_ffc30372": "The remote merge session is not ready",
    "k_2670db8f": "Code changes are ready. Review the diff before completing the branch merge",
    "k_483a9e79": "The code changed again. Confirm “Conflicts resolved” again",
    "k_b3d61dd7": "Resolve the code conflicts, then click “Conflicts resolved”",
    "k_aaf27633": "Review the code merge again, then click “Conflicts resolved”",
    "k_6535e010": "Failed to save the file. Please try again",
    "k_aa092da4": "A merge is already in progress",
    "k_61dcc213": "It may be running in another tab or device, or left by a page that closed unexpectedly. Restarting will cancel it, discard unfinished conflict resolution and code changes, and restore the container to its pre-merge state.",
    "k_2a2bf3f2": "Cancel it and restart",
    "k_15da4ca": "The current merge was cancelled",
    "k_7f1ed76d": "Failed to cancel the existing merge",
    "k_dcb07dc2": "Failed to cancel the merge. Please try again",
    "k_44b799d": "Unable to determine the AI page code revisions. Refresh and try again",
    "k_d4fd7411": "Unable to read the current branch AI project information. Refresh and try again",
    "k_37b333c4": "Confirm “Conflicts resolved” first",
    "k_e424d7ae": "The container could not prepare the code merge result",
    "k_93558b29": "Submitting the merged code from the container",
    "k_b7922bcf": "Save failed because conflicts remain unresolved",
    "k_993f6c8e": "Branch merge failed",
    "k_302958d8": "Unable to read the AI page code change list",
    "k_9c95fd56": "The AI page code change list has an invalid format",
    "k_e25a81e8": "The container returned an invalid code merge result",
    "k_54a6573b": "The container merge result does not match the reviewed revision",
    "k_5aaac01a": "Failed to start the code merge",
    "k_67a10bfb": "The container did not return a merged revision",
    "k_d7e675e1": "The local services bundle is not ready. Check port 1088 or upload the debug bundle again.",
    "k_7da916ad": "The remote merge session has closed",
    "k_4f7d37a6": "Save project",
    "k_282c462f": "File conflicts remain unresolved: {arg_0}",
    "k_cacaddea": "Failed to read file {arg_0}: {arg_1}",
    "k_1a737576": "[Wuji]{arg_0}",
    "k_500c37dc": "AI page path {arg_0} is already used by a non-AI page. Change one of the page paths first",
    "k_9a4110ec": "container/whoami did not return an rtx value",
    "k_aa311bd2": "Sync again",
    "k_4732b5d1": "Failed to get WeGit sync status",
    "k_6d01c553": "Syncing WeGit code. Please wait...",
    "k_52319f0d": "Contact a project administrator to complete the WeGit sync",
    "k_da7696e0": "WeGit sync failed. Please sync again"
};
